"use strict";

var KTApp = function () {
  /** @type {object} colors State colors **/
  var settings = {};

  var initTooltip = function (el) {
    var theme = el.data('theme') ? 'tooltip-' + el.data('theme') : '';
    var width = el.data('width') == 'auto' ? 'tooltop-auto-width' : '';
    var trigger = el.data('trigger') ? el.data('trigger') : 'hover';

    $(el).tooltip({
      trigger: trigger,
      template: '<div class="tooltip ' + theme + ' ' + width + '" role="tooltip">\
                <div class="arrow"></div>\
                <div class="tooltip-inner"></div>\
            </div>'
    });        
  }
    
  var initTooltips = function () {
    // init bootstrap tooltips
    $('[data-toggle="tooltip"]').each(function () {
      initTooltip($(this));
    });
  } 

  var initPopover = function (el) {
    var skin = el.data('skin') ? 'popover-' + el.data('skin') : '';
    var triggerValue = el.data('trigger') ? el.data('trigger') : 'hover';

    el.popover({
      trigger: triggerValue,
      template: '\
            <div class="popover ' + skin + '" role="tooltip">\
                <div class="arrow"></div>\
                <h3 class="popover-header"></h3>\
                <div class="popover-body"></div>\
            </div>'
    });
  }

  var initPopovers = function () {
    // init bootstrap popover
    $('[data-toggle="popover"]').each(function () {
      initPopover($(this));
    });
  }

  var detailOpen = function(event) {
    $(event).parent().find('.details').css('left', ($(event).position().left - 220) );
    $(event).parent().find('.details').css('top', ($(event).position().top - 10) );
    $(event).parent().find('.details').show(500);
  }

  var detailClose = function(event) { 
    $(event).parent().hide(500);
  }


  var initFileInput = function () {
    // init bootstrap popover
    $('.custom-file-input').on('change', function () {
      var fileName = $(this).val();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
    });
  }

  var initScroll = function () {
    $('[data-scroll="true"]').each(function () {
      var el = $(this);

      KTUtil.scrollInit(this, {
        mobileNativeScroll: true,
        handleWindowResize: true,
        rememberPosition: (el.data('remember-position') == 'true' ? true : false)
      });
    });
  }

  var initGoTop = function () {
    var rootElement = $('.card-scroll')[0];

    var scrollFunction = function(scrolledVal) {
      var go2top_button = $('#go2top_button')[0];
      var go2bottom_button = $('#go2bottom_button')[0];

      if(go2bottom_button != null){
        if (scrolledVal > 10) {
          go2bottom_button.style.display = 'block'
        } else {
          go2bottom_button.style.display = 'none';
        }
        if (Math.floor($(rootElement).scrollTop() + $(rootElement).innerHeight()) == rootElement.scrollHeight || Math.floor($(rootElement).scrollTop() + $(rootElement).innerHeight()) == rootElement.scrollHeight - 1) {
          go2bottom_button.style.display = 'none';
        }
      }

      if (go2top_button != null){
        if (scrolledVal > 90) {
          go2top_button.style.display = 'block';
        } else {
          go2top_button.style.display = 'none';
        }
      }
    };

    KTApp.topFunction = function() {
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    };

    KTApp.bottomFunction = function() {
      $(".card-scroll").animate({ scrollTop: rootElement.scrollHeight }, 1000);
    };

    if(typeof(rootElement) != "undefined"){
      rootElement.onscroll = function() {
        scrollFunction(rootElement.scrollTop);
      };
    }
  }

  var addNoneOptionToFilters = function() {
    $('[data-behaviour="select2-search-filter"]').each(function() {
      var newOption = new Option('--Not Assigned--', 'none', false, false);
      $(this).append(newOption);
    });
  }

  var initAlerts = function () {
    // init bootstrap popover
    $('body').on('click', '[data-close=alert]', function () {
      $(this).closest('.alert').hide();
    });
  }

  var initCard = function (el, options) {
    // init card tools
    var el = $(el);
    var card = new KTCard(el[0], options);
  }

  var initCards = function () {
    // init card tools
    $('[data-card="true"]').each(function () {
      var el = $(this);
      var options = {};

      if (el.data('data-card-initialized') !== true) {
        initCard(el, options);
        el.data('data-card-initialized', true);
      }
    });
  }

  var initStickyCard = function () {
    if (typeof Sticky === 'undefined') {
      return;
    }
    var sticky = new Sticky('[data-sticky="true"]');
  }

  var initAbsoluteDropdown = function (context) {
    var dropdownMenu;

    if (!context) {
      return;
    }

    $('body').on('show.bs.dropdown', context, function (e) {
      dropdownMenu = $(e.target).find('.dropdown-menu');
      $('body').append(dropdownMenu.detach());
      dropdownMenu.css('display', 'block');
      dropdownMenu.position({
        'my': 'right top',
        'at': 'right bottom',
        'of': $(e.relatedTarget),
      });
    }).on('hide.bs.dropdown', context, function (e) {
      $(e.target).append(dropdownMenu.detach());
      dropdownMenu.hide();
    });
  };

  var initAbsoluteDropdowns = function () {
    $('body').on('show.bs.dropdown', function (e) {
      // e.target is always parent (contains toggler and menu)
      var $toggler = $(e.target).find("[data-attach='body']");
      if ($toggler.length === 0) {
        return;
      }
      var $dropdownMenu = $(e.target).find('.dropdown-menu');
      // save detached menu
      var $detachedDropdownMenu = $dropdownMenu.detach();
      // save reference to detached menu inside data of toggler
      $toggler.data('dropdown-menu', $detachedDropdownMenu);

      $('body').append($detachedDropdownMenu);
      $detachedDropdownMenu.css('display', 'block');
      $detachedDropdownMenu.position({
        my: 'right top',
        at: 'right bottom',
        of: $(e.relatedTarget),
      });
    });

    $('body').on('hide.bs.dropdown', function (e) {
      var $toggler = $(e.target).find("[data-attach='body']");
      if ($toggler.length === 0) {
        return;
      }
      // access to reference of detached menu from data of toggler
      var $detachedDropdownMenu = $toggler.data('dropdown-menu');
      // re-append detached menu inside parent
      $(e.target).append($detachedDropdownMenu.detach());
      // hide dropdown
      $detachedDropdownMenu.hide();
    });

    $(document).on("click", ".dropdown-menu.keep-open", function(event) {
      event.stopPropagation();
    });

    $("button[data-behaviour='mdl_quick_search_form_closer']").on('click', function (event) {
      $(this).parents(2).removeClass('show');
    });

    $("button[data-behaviour='mdl_quick_search_form_clear']").on('click', function(event) {
      var form = $('#new_search');
      var checkbox = $('#simple_search_fields :input[type="checkbox"]');
      var inputs = form.find('#simple_search_fields :input:not([type=hidden])');
      setTimeout(function () {
        inputs.val(null).trigger('change');
        checkbox.prop('checked', false);
      }, 50);
    });
  };

  var filterDropdownList = function(input_field_id, dropdown_list_id) {
    var input = document.getElementById(input_field_id);
    var filter = input.value.toUpperCase();
    var div = document.getElementById(dropdown_list_id);
    var a = div.getElementsByTagName("a");
    for (var i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  };

  var initTypeahead = function() {
    $('[data-plugin="typeahead-object"]').each(function () {
      var $this = $(this);
      var collection_model = $this.attr('data-typeahead-collection');
      var active_source;

      if (collection_model === 'Fleet::Vehicle') {
        if (typeof window.vehiclesJson === 'undefined') {
          var vehiclesJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          vehiclesJson.initialize();
          window.vehiclesJson = vehiclesJson;
        }
        active_source = window.vehiclesJson;
      } else if (collection_model === 'Fleet::Driver') {
        if (typeof window.driversJson === 'undefined') {
          var driversJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          driversJson.initialize();
          window.driversJson = driversJson;
        }
        active_source = window.driversJson;
      } else if (collection_model === 'Logistics::Place') {
        var qry_place_type = $this.attr('data-typeahead-place-type');
        if (typeof window.placesJson === 'undefined') {
          var placesJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&place_type='+ qry_place_type +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          placesJson.initialize();
          window.placesJson = placesJson;
        }
        active_source = window.placesJson;
      } else if (collection_model === 'Network::Company') {
        if (typeof window.companiesJson === 'undefined') {
          var companiesJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          companiesJson.initialize();
          window.companiesJson = companiesJson;
        }
        active_source = window.companiesJson;
      } else if (collection_model === 'Network::Contact') {
        if (typeof window.contactsJson === 'undefined') {
          var contactsJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          contactsJson.initialize();
          window.contactsJson = contactsJson;
        }
        active_source = window.contactsJson;
      } else if (collection_model === 'Nimbos::City') {
        if (typeof window.citiesJson === 'undefined') {
          var citiesJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          citiesJson.initialize();
          window.citiesJson = citiesJson;
        }
        active_source = window.citiesJson;
      } else if (collection_model === 'Traderdec::GoodLocation') {
        function get_locations() {
          var result;
          $.ajax({
            type: "GET",
            url: "/traderdecs/get_good_locations",
            dataType: "JSON",
            async: false,
            success:function(data) {
              result = data;
            }
        });
        return result;
        }
        var locations = get_locations()

        var substringMatcher = function(strs) {
          return function findMatches(q, cb) {
            var matches, substringRegex;
            matches = [];
            var substrRegex = new RegExp(q, 'i');
            $.each(strs, function(i, str) {
              if (substrRegex.test(str.name)) {
                matches.push(str);
              }
            });
            cb(matches);
          };
        };
      } else if (collection_model === 'Logistics::Container') {
        if (typeof window.containersJson === 'undefined') {
          var containersJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          containersJson.initialize();
          window.containersJson = containersJson;
        }
        active_source = window.containersJson;
      } else if (collection_model === 'Nimbos::Region') {
        if (typeof window.regionsJson === 'undefined') {
          var regionsJson = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
              url: '/roster/autocompletes.json?model='+ collection_model +'&q=%QUERY',
              wildcard: '%QUERY'
            }
          });
          regionsJson.initialize();
          window.regionsJson = regionsJson;
        }
        active_source = window.regionsJson;
      }
      
      var display_name = 'text';
      if (collection_model === 'Nimbos::City') {
        display_name = 'name'
      }

      if (collection_model !== 'Traderdec::GoodLocation') {
        if ((!($this.hasClass('tt-input'))) && (!($this.hasClass('tt-hint')))) {
          $this.typeahead({ minLength: 2, highlight: true }, { name: $this.attr('id'), displayKey: display_name, source: active_source.ttAdapter() });
          $this.bind('typeahead:selected', function(ev, suggestion) {
            
            if ($this.attr('typeahead-mode') === 'nested') {
              var $this_name = $this.attr('name').split("[").pop().slice(0,-1);
              if (collection_model === 'Network::Company') {
                $("#" + $this.attr('id').replace($this_name, $this.attr('data-company-address'))).val(suggestion.address);
                $("#" + $this.attr('id').replace($this_name, $this.attr('data-company-email'))).val(suggestion.email);
                $("#" + $this.attr('id').replace($this_name, $this.attr('data-company-phone'))).val(suggestion.tel);
                $("#" + $this.attr('id').replace($this_name, $this.attr('data-company-id'))).val(suggestion.id);
              }
            } else {
              if (collection_model === 'Fleet::Vehicle') {
                $($this.attr('data-vehicle-id')).val(suggestion.id);
                $($this.attr('data-vehicle-country')).val(suggestion.country_id);
                $($this.attr('data-covehicle')).val(suggestion.covehicle_code);
                $($this.attr('data-vehicle-driver-id')).val(suggestion.driver_id);
                if (suggestion.driver_name === null && suggestion.person_name === null) {
                  $($this.attr('data-vehicle-driver-name')).val(suggestion.operator_name).trigger('input');
                } else if (suggestion.driver_name === null && suggestion.operator_name === null) {
                  $($this.attr('data-vehicle-driver-name')).val(suggestion.person_name).trigger('input');
                } else {
                  $($this.attr('data-vehicle-driver-name')).val(suggestion.driver_name).trigger('input');
                }
                $($this.attr('data-vehicle-driver-gsm')).val(suggestion.driver_gsm);
                $($this.attr('data-vehicle-owner-type')).val(suggestion.owner_type);
                $($this.attr('data-vehicle-type')).text(suggestion.vehicle_type);
              } else if (collection_model === 'Fleet::Driver') {
                $($this.attr('data-driver-id')).val(suggestion.id);
                $($this.attr('data-driver-tel')).val(suggestion.gsm);
              } else if (collection_model === 'Network::Company') {
                $($this.attr('data-company-id')).val(suggestion.id);
                $($this.attr('data-company-taxno')).val(suggestion.taxno);
                $($this.attr('data-company-city')).val(suggestion.city);
                $($this.attr('data-company-country')).val(suggestion.country_id).trigger('change');
                $($this.attr('data-company-address')).val(suggestion.address);
                $($this.attr('data-company-postcode')).val(suggestion.postcode);
                $($this.attr('data-company-taxoffice')).val(suggestion.taxoffice);
              } else if (collection_model === 'Nimbos::City') {
                $($this.attr('data-city-id')).val(suggestion.id);
                $($this.attr('data-city-country')).val(suggestion.country_id).trigger('change');
              } else if (collection_model === 'Logistics::Place') {
                $this.val(suggestion.name);
                $($this.attr('data-city-country')).val(suggestion.country_id).trigger('change');
              } else if (collection_model === 'Logistics::Container') {
                $this.val(suggestion.text);
              }
            }
          });
        }
      } else {
        $('#typeahead').typeahead(null, {
          name: 'locations',
          display: 'name',
          source: substringMatcher(locations)
        });
      }
    });
  };

  var initSelect2 = function() {
    $('[data-plugin="select2"]').select2({
      language: modaltrans.current_locale,
      allowClear: true,
      maximumSelectionLength: $(this).data('maximumSelectionLength'),
      placeholder: $(this).data('placeholder') || 'See options'
    });

    $('[data-plugin="lookup"]').each(function() {
      var $this = $(this);
      var options = $this.data();
      $this.select2({
      placeholder: options.placeholder,
      minimumInputLength: options.minimuminputlength,
      language: modaltrans.current_locale,
      allowClear: true,
      ajax: {
      url: options.url,
      dataType: "json",
      data: function(params) {
        var data_account_type_param = '';
        var data_parent_type2_param = '';
        var data_company_id         = '';
        var data_country_id         = '';
        var data_place_type_param   = '';
        var form_model = $this.data('form-model');
        var form_scope = $this.data('form-scope');
        if ($this.hasClass('account_select')) {
          var account_type_field = '#' + $this.attr('id').replace('account_id', 'account_type');
          if (typeof account_type_field !== typeof undefined && account_type_field !== false) {
            data_account_type_param = $(account_type_field).val();
          }
          var parent_type2_field = '#' + $this.attr('id').replace('account_id', 'parent_type2');
          if (typeof parent_type2_field !== typeof undefined && parent_type2_field !== false) {
            data_parent_type2_param = $(parent_type2_field).val();
          }
        }
        if ($this.hasClass('finitem_select')) {
          var debit_credit_selection = '#finitem_debit_credit_selection';
          if (typeof debit_credit_selection !== typeof undefined && debit_credit_selection !== false) {
            data_account_type_param = $(debit_credit_selection).val();
          }
        }
        if ($this.hasClass('place_select')) {
          var place_type_selection = $this.attr('data-place-type');
          if (typeof place_type_selection !== typeof undefined && place_type_selection !== false) {
            data_place_type_param = place_type_selection;
          }
          var place_country_selection = $this.attr('data-country-id');
          if (typeof place_country_selection !== typeof undefined && place_country_selection !== false) {
            data_country_id = place_country_selection;
          }
        }
        if ($this.hasClass('ledger_account_select')) {
          data_account_type_param = $this.attr('data-status');
        }
        if ($this.hasClass('vehicle-select') || $this.hasClass('contact-select')) {
          var company_selection = '#' + $this.attr('data-company-filter');
          if (typeof company_selection !== typeof undefined && company_selection !== false && $this.data('company-filter')) {
            data_company_id = $(company_selection).val();
          }
        }
        return {
          q: params.term,
          page_limit: 10,
          page: params.page,
          parent_type: data_account_type_param,
          parent_type2: data_parent_type2_param,
          company_id: data_company_id,
          country_id: data_country_id,
          source_form: form_model,
          list_scope: form_scope,
          place_type: data_place_type_param,
          apikey: modaltrans.account_token
        };
      },
      processResults: function(data, page) {
        return {
        results: data
        };
      },
      cache: true
      },
      language: {
      inputTooShort: function (args) {
        var remainingChars = args.minimum - args.input.length;
        var message = 'Please enter ' + remainingChars + ' or more characters';
        if(options.newurl) {
        message += '<a data-remote=true href=' + options.newurl +'?layout='+ modaltrans.current_layout +'&source_field='+ $this.attr('id') + ' class="pull-right float-right">Add New Item</a>';
        }
        return message;
      },
      noResults: function() {
        var message = 'No Results Found';
        if(options.newurl) {
        message += '<a data-remote=true href=' + options.newurl +'?layout='+ modaltrans.current_layout +'&source_field='+ $this.attr('id') + ' class="pull-right float-right">Add New Item</a>';
        }
        return message;
      }
      },
      escapeMarkup: function (markup) { return markup; },
      templateResult: formatRepo,
      templateSelection: formatRepoSelection
      });
    });

    $('[data-plugin="tag_select"]').each(function() {
      var $this = $(this);
      var options = $this.data();
      $this.select2({
      tags: true,
      tokenSeparators: [','],
      });
    });

    $('[data-plugin="multi_remote"]').each(function() {
      var $this = $(this);
      var options = $this.data();
      $this.select2({
        placeholder: options.placeholder,
        minimumInputLength: options.minimuminputlength,
        language: modaltrans.current_locale,
        allowClear: true,
        theme: "bootstrap",
        tags: true,
        tokenSeparators: [','],
        ajax: {
          url: options.url,
          dataType: "json",
          data: function(params) {
            return {
              q: params.term,
              page_limit: 20,
              page: params.page,
              apikey: modaltrans.account_token
            };
          }
        },
        cache: true
      });
    });

    function formatRepo (repo) {
      if (repo.loading) {
        return repo.text;
      }
      var markup = "<div class='select2-result-repository clearfix'><div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" + repo.text + "</div>";
      if (repo.notes) {
        markup += "<div class='select2-result-repository__description text-muted'>" + repo.notes + "</div>";
      }
      markup += "</div></div>";
      return markup;
    }

    function formatRepoSelection (repo) {
      return repo.text || repo.notes;
    }

    var set_finitem_details = function(finitem_field) {
      var finitem_selected = false
      var foreign_company_selected = false
      var company_country_id = ''
      var finitem_field_id_str      = '#' + $(finitem_field).attr('id');

      // Setting involine name
      var company_field = finitem_field_id_str.replace('finitem_id', 'company_id');
      if ( $(company_field).length ) {
        if (typeof $(company_field).select2('data')[0] !== typeof undefined && typeof $(company_field).select2('data')[0]['country_id'] !== typeof undefined) {
          var company_country_id = $(company_field).select2('data')[0]['country_id'];
          if ($(company_country_id).val() != '' && $(company_country_id).val() != modaltrans.current_country_id) {
            foreign_company_selected = true
          }
        }
      }
      if (company_country_id == '') {
        if ( $('#invoice_invoice_country_id').length ) {
          if ($('#invoice_invoice_country_id').val() != '' && $('#invoice_invoice_country_id').val() != modaltrans.current_country_id) {
            foreign_company_selected = true
          }
        }
      }
      if (finitem_field_id_str !== '#operation_finitem_id') {
        var name_field = finitem_field_id_str.replace('finitem_id', 'name');
        if ( $(name_field).length ) {
          if (typeof $(finitem_field).select2('data')[0] !== typeof undefined && typeof $(finitem_field).select2('data')[0]['text'] !== typeof undefined) {
            if (foreign_company_selected && $(finitem_field).select2('data')[0]['nmen'] != '' && $(finitem_field).select2('data')[0]['nmen'] != undefined) {
              $(name_field).val($(finitem_field).select2('data')[0]['nmen']);
            } else {
              $(name_field).val($(finitem_field).select2('data')[0]['text']);
            }
            finitem_selected = true
          }
        }
      }
  
      if (finitem_selected) {
        // Setting unit_price
        var unit_price_field  = finitem_field_id_str.replace('finitem_id', 'unit_price');
        var finitem_unit_price = $(finitem_field).select2('data')[0]['sales_price'];
        if (typeof unit_price_field !== typeof undefined && unit_price_field !== false && finitem_unit_price != null) {
          if ($(unit_price_field).val() == '' || ($(unit_price_field).val() == 0)) {
            $(unit_price_field).val(finitem_unit_price).trigger('change');
          }
        }
        // Setting currency
        var currency_field  = finitem_field_id_str.replace('finitem_id', 'curr');
        var finitem_curr = $(finitem_field).select2('data')[0]['sales_curr'];
        if (typeof currency_field !== typeof undefined && currency_field !== false && finitem_curr != null) {
          if ($(currency_field).val() == '') {
            $(currency_field).val(finitem_curr).trigger('change');
          }
        }
        // Setting vat_id
        var debit_credit_field = '#finitem_debit_credit_selection';
        var debit_credit_val = 'debit';
        if (typeof debit_credit_field !== typeof undefined && debit_credit_field !== false && debit_credit_field != null) {
          if ($(debit_credit_field).length) {
            var debit_credit_val = $(debit_credit_field).val();
          }
        }
        var vat_id_field  = finitem_field_id_str.replace('finitem_id', 'vat_id');
        var finitem_vat_id = $(finitem_field).select2('data')[0]['sales_tax_id'];
        if (debit_credit_val === 'credit') {
          finitem_vat_id = $(finitem_field).select2('data')[0]['purchase_tax_id'];
        }

        if (typeof vat_id_field !== typeof undefined && vat_id_field !== false && finitem_vat_id != null) {
          if ($(vat_id_field).val() == '' || $(vat_id_field).val().length) {
            $(vat_id_field).val(finitem_vat_id).trigger('change');
          }
        }
        // Setting tax_exclude_code
        var tax_exclude_code_field   = finitem_field_id_str.replace('finitem_id', 'tax_exclude_code');
        var finitem_tax_exclude_type = $(finitem_field).select2('data')[0]['tax_exclude_type'];
        var finitem_tax_exclude_code = $(finitem_field).select2('data')[0]['tax_exclude_code'];

        if (typeof tax_exclude_code_field !== typeof undefined && finitem_tax_exclude_type !== "none" && tax_exclude_code_field !== false && tax_exclude_code_field !== null ) {
          if ($(tax_exclude_code_field).val() == '') {
            $(tax_exclude_code_field).val(finitem_tax_exclude_code).trigger('change');
          }
        }
        // Setting tax_exclude_account_id and discount_vat_account_id
        var tax_exclude_account_id_field     = finitem_field_id_str.replace('finitem_id', 'tax_exclude_account_id');
        var finitem_tax_exclude_account_id   = $(finitem_field).select2('data')[0]['tax_exclude_account_id'];
        var finitem_tax_exclude_account_name = $(finitem_field).select2('data')[0]['tax_exclude_account_name'];

        var discount_vat_account_id_field     = finitem_field_id_str.replace('finitem_id', 'discount_vat_account_id');
        var finitem_discount_vat_account_id   = $(finitem_field).select2('data')[0]['discount_vat_account_id'];
        var finitem_discount_vat_account_name = $(finitem_field).select2('data')[0]['discount_vat_account_name'];

        var finitem_tax_exclude_type         = $(finitem_field).select2('data')[0]['tax_exclude_type'];

        if (typeof tax_exclude_account_id_field !== typeof undefined && (finitem_tax_exclude_type === "credit" || finitem_tax_exclude_type === "both" ) && finitem_tax_exclude_account_id !== null && finitem_tax_exclude_account_name !== null && tax_exclude_account_id_field !== false && tax_exclude_account_id_field !== null) {
          if ($(tax_exclude_account_id_field).val() == '') {
            $(tax_exclude_account_id_field).append("<option value='"+finitem_tax_exclude_account_id+"' selected>"+finitem_tax_exclude_account_name+"</option>").trigger('change');
          }
        }
        if (typeof discount_vat_account_id_field !== typeof undefined && (finitem_tax_exclude_type === "credit" || finitem_tax_exclude_type === "both" ) && finitem_discount_vat_account_id !== null && finitem_discount_vat_account_name !== null && discount_vat_account_id_field !== false && discount_vat_account_id_field !== null) {
          if ($(discount_vat_account_id_field).val() == '') {
            $(discount_vat_account_id_field).append("<option value='"+finitem_discount_vat_account_id+"' selected>"+finitem_discount_vat_account_name+"</option>").trigger('change');
          }
        }

        // if there is auto calculation, find main finitem and total amount value
        var finitem_auto_calc_id = $(finitem_field).select2('data')[0]['auto_calc_finitem_id'];
        var finitem_auto_calc_rt = $(finitem_field).select2('data')[0]['auto_calc_rate'];
        if (typeof finitem_auto_calc_id !== typeof undefined && finitem_auto_calc_id !== null && finitem_auto_calc_id !== false) {
          var finitems = document.getElementsByClassName("finitem_select");
          for (var i = 0; i < finitems.length; i++) {
            var previous_item = finitems.item(i);
            if ((previous_item.value !== '') && (previous_item.id !== finitem_field.id) && (finitem_auto_calc_id == previous_item.value)) {
              var prev_price_field  = document.getElementById(previous_item.id.replace('finitem_id', 'unit_price'));
              if ((typeof prev_price_field !== typeof undefined) && (prev_price_field !== false) && (prev_price_field.value > 0)) {
                var target_price_field   = document.getElementById(finitem_field.id.replace('finitem_id', 'unit_price'));
                target_price_field.value = (prev_price_field.value * finitem_auto_calc_rt / 100).toFixed(2);
                // var target_unit_field   = document.getElementById(finitem_field.id.replace('finitem_id', 'unit_number'));
                // target_unit_field.value = document.getElementById(previous_item.id.replace('finitem_id', 'unit_number')).value;
              }
            }
          }
        }
      }
    };

    $(document).on("change", ".finitem_select", function (event) {
      set_finitem_details(this);
    });

    var change_combobox_options, fill_contact_list, get_company_contacts;

    get_company_contacts = function(company_select) {
      return $.ajax({
        type: "GET",
        url: "/contacts?company_id=" + company_select.val(),
        dataType: "JSON",
        success: function(data) {
          return fill_contact_list(company_select, data);
        }
      });
    };

    fill_contact_list = function(company_select, data) {
      var contact_data, contactsJson, i, item;
      contact_data = [];
      i = 0;
      while (i < data.length) {
        item = {};
        item["id"] = data[i]["id"].toString();
        item["text"] = data[i]["name"];
        if (data[i]["email"] !== "") {
          item["text"] += " <" + data[i]["email"] + ">";
        }
        contact_data.push(item);
        i++;
      }
      contactsJson = JSON.stringify(contact_data);
      change_combobox_options('#' + company_select.data('contact-field'), JSON.parse(contactsJson), true);
    };

    change_combobox_options = function(comboBoxID, newOptions, resetOptions) {
      var comboBox, options;
      comboBox = $(comboBoxID);
      if (comboBox.prop) {
        options = comboBox.prop("options");
      } else {
        options = comboBox.attr("options");
      }
      if (resetOptions) {
        $("option", comboBox).remove();
      }
      $.each(newOptions, function(val, contact) {
        return options[options.length] = new Option(contact["text"], contact["id"]);
      });
      comboBox.trigger('change');
    };

    $(document).on("change", "#notice_company_id[data-contact-field!='']", function (event) {
      get_company_contacts($(this));
    });

    var set_ledger_account_details = function(ledger_account_field) {
      var ledger_account_field_id_str = '#' + $(ledger_account_field).attr('id');

      var name_field = ledger_account_field_id_str.replace('ledger_account_id', 'name');
      if (typeof name_field !== typeof undefined && name_field !== false) {
        if (typeof $(ledger_account_field).select2('data')[0] !== typeof undefined && typeof $(ledger_account_field).select2('data')[0]['name'] !== typeof undefined) {
          if ($(name_field).val() == '') {
            $(name_field).val($(ledger_account_field).select2('data')[0]['name']);
          }
        }
      }
    };

    var set_select2_company_values = function(selected_company) {
      if ($(selected_company).val() != '') {
        if ($(selected_company).data('saler-field') !== '' && $(selected_company).select2('data')[0]['saler_id'] !== '' && $(selected_company).select2('data')[0]['saler_id'] !== null && $(selected_company).select2('data')[0]['saler_id'] !== typeof undefined) {
          var newOption = new Option($(selected_company).select2('data')[0]['saler_name'], $(selected_company).select2('data')[0]['saler_id'], false, true);
          $('#'+$(selected_company).data('saler-field')).append(newOption).trigger('change');
        }
        if ($(selected_company).data('country-field') !== '' && $(selected_company).select2('data')[0]['country_id'] !== '' && $(selected_company).select2('data')[0]['country_id'] !== null && $(selected_company).data('country-field') !== '' && $(selected_company).data('country-field') !== typeof undefined) {
          $('#'+$(selected_company).data('country-field')).val($(selected_company).select2('data')[0]['country_id']).trigger('change');
        }
        if ($(selected_company).data('eori-field') !== '' && $(selected_company).select2('data')[0]['eori_code'] !== '' && $(selected_company).select2('data')[0]['eori_code'] !== null && $(selected_company).data('eori-field') !== '' && $(selected_company).data('eori-field') !== typeof undefined) {
          $('#'+$(selected_company).data('eori-field')).val($(selected_company).select2('data')[0]['eori_code']).trigger('change');
        }
        if ($(selected_company).data('name-field') !== '' && $(selected_company).select2('data')[0]['name'] !== '' && $(selected_company).select2('data')[0]['name'] !== null && $(selected_company).data('name-field') !== '' && $(selected_company).data('name-field') !== typeof undefined) {
          $('#'+$(selected_company).data('name-field')).val($(selected_company).select2('data')[0]['name']).trigger('change');
        }
        if ($(selected_company).data('address-field') !== '' && $(selected_company).select2('data')[0]['address'] !== '' && $(selected_company).select2('data')[0]['address'] !== null && $(selected_company).data('address-field') !== '' && $(selected_company).data('address-field') !== typeof undefined) {
          $('#'+$(selected_company).data('address-field')).val($(selected_company).select2('data')[0]['address']).trigger('change');
        }
        if ($(selected_company).data('city-name-field') !== '' && $(selected_company).select2('data')[0]['city_name'] !== '' && $(selected_company).select2('data')[0]['city_name'] !== null && $(selected_company).data('city-name-field') !== '' && $(selected_company).data('city-name-field') !== typeof undefined) {
          $('#'+$(selected_company).data('city-name-field')).val($(selected_company).select2('data')[0]['city_name']).trigger('change');
        }
        if ($(selected_company).data('country-id-field') !== '' && $(selected_company).select2('data')[0]['country_id'] !== '' && $(selected_company).select2('data')[0]['country_id'] !== null && $(selected_company).data('country-id-field') !== '' && $(selected_company).data('country-id-field') !== typeof undefined) {
          $('#'+$(selected_company).data('country-id-field')).val($(selected_company).select2('data')[0]['country_id']).trigger('change');
        }
        if ($(selected_company).data('postcode-field') !== '' && $(selected_company).select2('data')[0]['postcode'] !== '' && $(selected_company).select2('data')[0]['postcode'] !== null && $(selected_company).data('postcode-field') !== '' && $(selected_company).data('postcode-field') !== typeof undefined) {
          $('#'+$(selected_company).data('postcode-field')).val($(selected_company).select2('data')[0]['postcode']).trigger('change');
        }
        if ($(selected_company).data('taxno-field') !== '' && (typeof $(selected_company).data('taxno-field') !== typeof undefined) && $(selected_company).select2('data')[0]['taxno'] !== '' && $(selected_company).select2('data')[0]['taxno'] !== null) {
          $('#'+$(selected_company).data('taxno-field')).val($(selected_company).select2('data')[0]['taxno']).trigger('change');
        }
        if ($(selected_company).data('curr-field') !== '' && (typeof $(selected_company).data('curr-field') !== typeof undefined) && $(selected_company).select2('data')[0]['curr'] !== '' && $(selected_company).select2('data')[0]['curr'] !== null && (modaltrans.country_id !== "TR")) {
          $('#'+$(selected_company).data('curr-field')).val($(selected_company).select2('data')[0]['curr']).trigger('change');
        }
        if ($(selected_company).data('credit-limit-curr-field') !== '' && (typeof $(selected_company).data('credit-limit-curr-field') !== typeof undefined) && $(selected_company).select2('data')[0]['credit_limit_curr'] !== '' && $(selected_company).select2('data')[0]['credit_limit_curr'] !== null ) {
          $('#'+$(selected_company).data('credit-limit-curr-field')).val($(selected_company).select2('data')[0]['credit_limit_curr']).trigger('change');
        }
        if ($(selected_company).data('credit-limit-field') !== '' && (typeof $(selected_company).data('credit-limit-field') !== typeof undefined) && $(selected_company).select2('data')[0]['credit_limit'] !== '' && $(selected_company).select2('data')[0]['credit_limit'] !== null ) {
          $('#'+$(selected_company).data('credit-limit-field')).val($(selected_company).select2('data')[0]['credit_limit']).trigger('change');
        }
      } else {
        if ($(selected_company).data('saler-field') !== '') {
          $('#'+$(selected_company).data('saler-field')).val(null).trigger('change');
        }
      }
    };

    var show_company_financial_details = function(company_field) {
      var fin_status   = $(company_field).select2('data')[0]['financial_status'];
      var fin_info_div = $(company_field).data('financial-detail');
      var fin_element  = $("#company_financial_details");
  
      if(typeof fin_element !== 'undefined' && fin_element !== null) {
        fin_element.className = "alert alert-warning padding-0";
        if ((fin_status !== 'active') && (fin_info_div !== '') && (typeof fin_info_div !== typeof undefined)) {
          $('#' + fin_info_div).html($(company_field).select2('data')[0]['financial_notes']);
        }
      }
      if (($(company_field).attr('data-branch-field') !== null) && ($(company_field).attr('data-branch-field') !== '')) {
        var branch_field = $('#'+$(company_field).attr('data-branch-field'));
        if(typeof branch_field !== 'undefined' && branch_field !== null) {
          branch_field.val($(company_field).select2('data')[0]['branch_id']).trigger('change');
        }
      }
    };

    var updatePlaceFields = function(place_field_id_str) {
      var place_field = document.getElementById(place_field_id_str);
      var selected_place_id = $('#'+place_field_id_str).select2('data')[0]['id'];
      if (typeof place_field == typeof undefined || place_field == false || place_field == null || place_field.value == '' || selected_place_id == "") {
        return;
      }

      var country_field = place_field.getAttribute('data-country-field');
      if ((country_field !== '') && (country_field !== null) && (document.getElementById(country_field) === null)) {
        country_field   = place_field_id_str.replace('place_id', 'country_id');
      }
      if (document.getElementById(country_field) !== null) {
        if (typeof $(place_field).select2('data')[0] !== typeof undefined && typeof $(place_field).select2('data')[0]['country_id'] !== typeof undefined) {
          $('#'+country_field).val($(place_field).select2('data')[0]['country_id']).trigger('change');
        }
      }

      var city_field = place_field.getAttribute('data-city-field');
      if (city_field !== '' && city_field !== null && (document.getElementById(city_field) === null)) {
        city_field   = place_field_id_str.replace('place_id', 'city_id');
      }
      if (document.getElementById(city_field) !== null) {
        if (typeof $(place_field).select2('data')[0] !== typeof undefined && typeof $(place_field).select2('data')[0]['city_id'] !== typeof undefined) {
          $('#'+city_field).append("<option value='"+$(place_field).select2('data')[0]['city_id']+"' selected>"+$(place_field).select2('data')[0]['city_name']+"</option>").trigger('change');
        }
      }

      var postcode_field = place_field.getAttribute('data-postcode-field');
      if (postcode_field != '' && postcode_field != null && (document.getElementById(postcode_field) === null)) {
        postcode_field   = place_field_id_str.replace('place_id', 'postcode');
      }
      if (document.getElementById(postcode_field) !== null) {
        if (typeof $(place_field).select2('data')[0] !== typeof undefined && typeof $(place_field).select2('data')[0]['post_code'] !== typeof undefined) {
          $('#'+postcode_field).val($(place_field).select2('data')[0]['post_code']);
        }
      }

      var address_field = place_field.getAttribute('data-address-field');
      if (address_field != '' && address_field != null && (document.getElementById(address_field) === null)) {
        address_field   = place_field_id_str.replace('place_id', 'address');
      }
      if (document.getElementById(address_field) !== null) {
        if (typeof $(place_field).select2('data')[0] !== typeof undefined && typeof $(place_field).select2('data')[0]['address'] !== typeof undefined) {
          $('#'+address_field).val($(place_field).select2('data')[0]['address']);
        }
      }

      var latitude_field = place_field.getAttribute('data-latitude-field');
      if (latitude_field != '' && latitude_field != null && (document.getElementById(latitude_field) === null)) {
        latitude_field   = place_field_id_str.replace('place_id', 'lat');
      }
      if (document.getElementById(latitude_field) !== null) {
        if (typeof $(place_field).select2('data')[0] !== typeof undefined && typeof $(place_field).select2('data')[0]['lat'] !== typeof undefined) {
          $('#'+latitude_field).val($(place_field).select2('data')[0]['lat']);
        }
      }

      var longitude_field = place_field.getAttribute('data-longitude-field');
      if (longitude_field != '' && longitude_field != null && (document.getElementById(longitude_field) === null)) {
        longitude_field = place_field_id_str.replace('place_id', 'lng');
      }
      if (document.getElementById(longitude_field) !== null) {
        if (typeof $(place_field).select2('data')[0] !== typeof undefined && typeof $(place_field).select2('data')[0]['lng'] !== typeof undefined) {
          $('#'+longitude_field).val($(place_field).select2('data')[0]['lng']);
        }
      }
    };

    $(document).on("change", ".place_select", function() {
      if ($(this).attr('data-place-behaviour') == 'skip') {
        return;
      }
      updatePlaceFields($(this).attr('id'));
    });


    $(document).on("change", ".city-select[data-city-field!='']", function(e) {
      var country_input = $(this).data("country_id");
      if (country_input === null || country_input === '') {
        country_input = $(this).attr("id").replace('city_id', 'country_id');
      }
      if (typeof country_input !== typeof undefined && country_input !== false && country_input !== null && country_input !== '') {
        var selectedData = $(this).select2('data');
        var country_id = (selectedData && selectedData.length > 0) ? selectedData[0]['country_id'] : null;
        if (typeof country_id !== typeof undefined && country_id !== null && country_id !== '') {
          $('#' + country_input).val(country_id).trigger('change');
        }
      }
    });

    $(document).on("select2:select", ".company-select", function(e) {
      var changed_field_id, label_element, label_text, selected_company_id, bid_company_field_id,bid_email_field;
      changed_field_id = $(this).attr('id');

      selected_company_id = $(this).val();

      label_element = $('label[for=\'' + changed_field_id + '\']');

      label_text = $(label_element).html();

      if (label_text !== undefined && label_text.includes('profile-link')) {
        label_text = label_text.substr(0, label_text.indexOf('<a href'));
      }
      $(label_element).html(label_text + '<a href=/companies/' + selected_company_id + ' target="_blank" class="float-right profile-link"> Profile</a>');

      if(changed_field_id.includes('tender_bids')){
        bid_company_field_id = '#' + changed_field_id;
        bid_email_field = bid_company_field_id.replace('company_id', 'email');

        if (typeof bid_email_field !== typeof undefined && bid_email_field !== false) {
          $.ajax({
            type: "GET",
            url: "/bids/find_bid_email",
            dataType: "json",
            data: {
              company_id: selected_company_id
            },
            success: function(data) {
              if (data != null) {
                $(bid_email_field).val(data['email']);
              }
            }
          });
        }      
      }
    });

    $(document).on("select2:select", ".email-select", function(e) {
      var changed_field_id, selected_email_addr, target_field;
      changed_field_id = $(this).attr('id');
      selected_email_addr = $(this).val();
      target_field = changed_field_id.replace('_ids', '');
      append_email_to_list(target_field, selected_email_addr);
    });

    $(document).on("change", ".company-select", function(event) {
      set_select2_company_values(this);
      show_company_financial_details(this);
    });

    var set_package_type_field = function(pack_code_field_id) {
      var pack_type_field_id = '#' + pack_code_field_id.replace('pack_code', 'pack_type');
      if (typeof pack_type_field_id !== typeof undefined && pack_type_field_id !== false) {
        $(pack_type_field_id).val($('#' + pack_code_field_id).find("option:selected").text());
      }
    };

    $(document).on("change", ".package-type-code", function(event) {
      set_package_type_field($(this).attr('id'));
    });

    $(document).on("change", "#timeoff_person_id", function(event) {
      if($(this).val() != '') {
        return get_timeoff_sum($(this).val());
      }
    });


    var get_timeoff_sum = function(person_id) {
      $.ajax({
        type: "GET",
        url: "/get_timeoff_sum",
        dataType: "script",
        data: {
          person_id: person_id,
        }
      });
    };
    
    $(document).on("change", "#timeoff_weekend_days", function(event) {
      var start_date  = $(".timeoff-start-date").val();
      var finish_date = $(".timeoff-finish-date").val();
      var reason      = $(".timeoff-reason").val();
      get_timeoff_credit(start_date, finish_date, reason);
    });

    var get_timeoff_credit = function(start_date, finish_date, reason) {
      var weekend_days = $("#timeoff_weekend_days").val();
      $.ajax({
        type: "GET",
        url: "/find_credit",
        dataType: "json",
        data: {
          start_date: start_date,
          finish_date: finish_date,
          reason: reason,
          weekend_days: weekend_days
        },
        success: function(data) {
          if (data != null) {
            $('#timeoff_credit').val(data[0]);
            
            if (data[1] != null) {
              $(document).find("#timeoff_beginning_date").val(data[1]);
              var visible_date   = new Date(data[1]);
              var nd = visible_date.getDate();
              var nm = visible_date.getMonth() + 1 ;
              var ny = visible_date.getFullYear();
              var visible_date = nd + "/" + nm +"/" + ny;
              $(document).find(".timeoff-beginning-date").val(visible_date);
              var a = $(document).find("#timeoff_person_id").val();
            }
          }
        }
      });
    };

    var set_saler_id_on_motion = function(id) {
      return $.ajax({
      type: "GET",
      url: "/companies/" + id,
      dataType: "JSON",
      success: function(data) {
        if (data != null && data != '' && data['saler_id'] != undefined) {
          var $option = $("<option selected></option>").val(data['saler_id']).text(data['saler_name']);
          $('.depot_motion_saler_id').append($option).trigger('change');
        } else {
          $(".depot_motion_saler_id").empty();
          $('.depot_motion_saler_id').val('').trigger('change.select2');
        }
      }
      });
    };

    $(document).on("change", ".part-select", function(event) {
      if($(this).val() != '') {
        set_purchaseline_details($(this));
      }
    });

    var set_purchaseline_details = function(part_field) {
      var part_field_id_str = '#' + $(part_field).attr('id');
      var $unit_price = part_field_id_str.replace("part_id", 'unit_price');
      var $notes      = part_field_id_str.replace("part_id", 'notes');
      var $unit_count = part_field_id_str.replace("part_id", 'unit_count');
      var $unit_type  = part_field_id_str.replace("part_id", 'unit_type');
      var $amount      = part_field_id_str.replace("part_id", 'amount');
      return $.ajax({
        type: "GET",
        url: "/parts/" + part_field.val(),
        dataType: "JSON",
        success: function(data) {
          if (data != null && data != '') {
            $($unit_price).val(data["purchase_price"]);
            $($amount).val(data["purchase_price"]);
            $($notes).val(data["notes"]);
            $($unit_count).val(1);
            if(data["unit_type"]== null || data["unit_type"]==undefined || data["unit_type"]=='')
            {
              $($unit_type).val("count");
            }
            else
            {
              $($unit_type).val(data["unit_type"]);
            };
            $($unit_type).trigger('change');
          }
        }
      });
    };

    $(document).on("change", ".purchaseline-unit-count", function(event) {
      set_purchaseline_amount($(this), "unit_count");
    });

    $(document).on("change", ".purchaseline-unit-price", function(event) {
      set_purchaseline_amount($(this), "unit_price");
    });

    var set_purchaseline_amount = function(object, unit_select) {
      var part_field_id_str = '#' + $(object).attr('id');

      var unit_count_str = ""
      var unit_price_str = ""
      var amount_str      = ""

      if (unit_select == "unit_price") {
        var unit_price_str = part_field_id_str
        var unit_count_str = part_field_id_str.replace("unit_price", 'unit_count');
        var amount_str     = part_field_id_str.replace("unit_price", 'amount');
      }
      else {
        var unit_count_str = part_field_id_str
        var unit_price_str = part_field_id_str.replace("unit_count", 'unit_price');
        var amount_str     = part_field_id_str.replace("unit_count", 'amount');
      };

      var unit_number  = $(unit_count_str).val() || $(unit_count_str).html() || 1;
      var unit_price   = $(unit_price_str).val() || $(unit_price_str).html() || 1;

      var total_amount = (unit_price * unit_number);
      $(amount_str).val(total_amount);
    };
    
    $(document).on("change", "#cwh_motion_company_id", function(event) {
      if ($(this).val() != '') {
        set_saler_id_on_motion($(this).val());
      }
    });
    
    $(document).on("change", "#free_motion_company_id", function(event) {
      if ($(this).val() != '') {
        set_saler_id_on_motion($(this).val());
      }
    });

    $(document).on("change", "#reminder_account_type", function(event) {
      $('#reminder_account_id').val(null).trigger('change');
    });
    
    var get_company_locations = function(company_id, target_list, nested="") {
      if (company_id == null || company_id == '' || company_id == undefined) {

        $('#'+target_list).hide();
        return false;
      } else {
        return $.ajax({
          type: "GET",
          url: "/places?list_scope="+ target_list + "&company_id=" + company_id + "&nested=" + nested,
          dataType: "script"
        });
      }
    };

    var set_location_hint = function (address, select_id) {
      var select = $('#' + select_id)
      var company_address = address === '' ? 'No address' : address;
      select.parent('div').find('.location_hint').remove();
      select.parent('div').append('<span id="location_hint" class="location_hint help-block text-warning error-inputs truncate">' + company_address + '</span>');
    }
  
    var set_company_address = function(company_data, address_type) {
      if (address_type === "loading") {
        var city_id   = company_data['city_id'];
        var city_name = company_data['city_name'];
        $('[name="loading[load_place]"]').val(company_data['address']);
        $('#loading_dep_zipcode').val(company_data['postcode']);
        $('#loading_load_coun').val(company_data['country_id']).trigger('change');
        $('#loading_load_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
        $('#loading_load_state_name').val(company_data['state']);
        $('#loading_dep_lat').val(company_data['lat']);
        $('#loading_dep_lng').val(company_data['lng']);

        set_location_hint(company_data['address'], 'loading_loader_id');
      }
      if (address_type === "unloading") {
        console.log('girdi')
        var city_id   = company_data['city_id'];
        var city_name = company_data['city_name'];
        $('[name="loading[unload_place]"]').val(company_data['address']);
        $('#loading_arv_zipcode').val(company_data['postcode']);
        $('#loading_unload_coun').val(company_data['country_id']).trigger('change');
        $('#loading_unload_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
        $('#loading_unload_state_name').val(company_data['state']);
        $('#loading_arv_lat').val(company_data['lat']);
        $('#loading_arv_lng').val(company_data['lng']);

        set_location_hint(company_data['address'], 'loading_delivery_id');
      }
      if (address_type === "origin_company_locations") {
        var city_id   = company_data['city_id'];
        var city_name = company_data['city_name'];
        $('#point_origin_address').val(company_data['address']);
        $('#point_origin_postcode').val(company_data['postcode']);
        $('#point_origin_country_id').val(company_data['country_id']).trigger('change');
        $('#point_origin_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
        $('#point_origin_lat').val(company_data['lat']);
        $('#point_origin_lng').val(company_data['lng']);
      }
      if (address_type === "destination_company_locations") {
        var city_id   = company_data['city_id'];
        var city_name = company_data['city_name'];
        $('#point_destination_address').val(company_data['address']);
        $('#point_destination_postcode').val(company_data['postcode']);
        $('#point_destination_country_id').val(company_data['country_id']).trigger('change');
        $('#point_destination_city_id').append("<option value='" + city_id + "' selected>" + city_name + "</option>").trigger('change');
        $('#point_destination_lat').val(company_data['lat']);
        $('#point_destination_lng').val(company_data['lng']);
      }
      if (address_type === "good_sender") {
        $('#good_sender_address').val(company_data['address']);
        $('#good_sender_postcode').val(company_data['postcode']);
        $('#good_sender_city').val(company_data['city_name']);
        $('#good_sender_name').val(company_data['name']);
        $('#good_sender_taxno').val(company_data['taxno']);
        $('#good_sender_eori_code').val(company_data['eori_code']);
        $('#good_sender_country_id').val(company_data['country_id']).trigger('change');
      }
      if (address_type === "good_consignee") {
        $('#good_consignee_address').val(company_data['address']);
        $('#good_consignee_postcode').val(company_data['postcode']);
        $('#good_consignee_city').val(company_data['city_name']);
        $('#good_consignee_name').val(company_data['name']);
        $('#good_consignee_taxno').val(company_data['taxno']);
        $('#good_consignee_eori_code').val(company_data['eori_code']);
        $('#good_consignee_country_id').val(company_data['country_id']).trigger('change');
      }
      if (address_type === "dep_place") {
        $('#position_dep_place_name').val(company_data['name'] + ' - Headquarters');
        $('[name="position[dep_address]"]').val(company_data['address']);
        $('#position_dep_postcode').val(company_data['postcode']);
        $('#position_dep_city_id').val(company_data['city_id']).trigger('change');
        $('#position_dep_city_name').val(company_data['city_name']);
        $('#position_dep_state_name').val(company_data['state']);
        $('#position_coagent_name').val(company_data['name']);
        $('#position_dep_country_id').val(company_data['country_id']).trigger('change');
        $('#position_dep_lat').val(company_data['lat']);
        $('#position_dep_lng').val(company_data['lng']);

        set_location_hint(company_data['address'], 'position_coagent_id');
      }
      if (address_type === "arv_place") {
        $('#position_arv_place_name').val(company_data['name'] + ' - Headquarters');
        $('[name="position[arv_address]"]').val(company_data['address']);
        $('#position_arv_postcode').val(company_data['postcode']);
        $('#position_arv_city_id').val(company_data['city_id']).trigger('change');
        $('#position_arv_city_name').val(company_data['city_name']);
        $('#position_arv_state_name').val(company_data['state']);
        $('#position_agent_name').val(company_data['name']);
        $('#position_arv_country_id').val(company_data['country_id']).trigger('change');
        $('#position_arv_lat').val(company_data['lat']);
        $('#position_arv_lng').val(company_data['lng']);

        set_location_hint(company_data['address'], 'position_agent_id');
      }
    };

    var set_nested_company_address = function(companyData, nestedCompanyId) {
      $("#" + nestedCompanyId.replace("company_id", "name")).val(companyData.name + ' - Headquarters');
      $("." + nestedCompanyId.replace("company_id", "address")).val(companyData.address);
      $("#" + nestedCompanyId.replace("company_id", "postcode")).val(companyData.postcode);
      $("#" + nestedCompanyId.replace("company_id", "city_id")).val(companyData.city_id).trigger('change');
      $("#" + nestedCompanyId.replace("company_id", "city_name")).val(companyData.city_name);
      $("#" + nestedCompanyId.replace("company_id", "state_name")).val(companyData.state);
      $("#" + nestedCompanyId.replace("company_id", "country_id")).val(companyData.country_id).trigger('change');
      $("#" + nestedCompanyId.replace("company_id", "lat")).val(companyData.lat);
      $("#" + nestedCompanyId.replace("company_id", "lng")).val(companyData.lng);
    
      set_location_hint(companyData.address, nestedCompanyId);
    }

    var set_sender_infos = function() {
      $('#uetd_line_sender_name').val($('#uetd_line_sender_id').select2('data')[0]['name']);
      $('#uetd_line_sender_taxno').val($('#uetd_line_sender_id').select2('data')[0]['taxno']);
      $('#uetd_line_dep_country_id').val($('#uetd_line_sender_id').select2('data')[0]['country_id']).trigger('change');
      $('#uetd_line_dep_city_id').append("<option value='" + $('#uetd_line_sender_id').select2('data')[0]['city_id'] + "' selected>" + $('#uetd_line_sender_id').select2('data')[0]['city_name'] + "</option>").trigger('change');
    };
  
    var set_consignee_infos = function() {
      $('#uetd_line_consignee_name').val($('#uetd_line_consignee_id').select2('data')[0]['name']);
      $('#uetd_line_consignee_taxno').val($('#uetd_line_consignee_id').select2('data')[0]['taxno']);
      $('#uetd_line_arv_country_id').val($('#uetd_line_consignee_id').select2('data')[0]['country_id']).trigger('change');
      $('#uetd_line_arv_city_id').append("<option value='" + $('#uetd_line_consignee_id').select2('data')[0]['city_id'] + "' selected>" + $('#uetd_line_consignee_id').select2('data')[0]['city_name'] + "</option>").trigger('change');
    };

    var set_load_place = function() {
      $('#manifesto_load_place').val($('#manifesto_dispatch_country_id').val());
    };

    var set_unload_place = function() {
      $('#manifesto_unload_place').val($('#manifesto_destination_country_id').val());
    };

    var set_gtip_infos = function() {
      if ($('#good_gtip_id').select2('data').length > 0) {
        if ($('#good_gtip_id').val()){
          $('#good_commodity').val($('#good_gtip_id').select2('data')[0]['name']).trigger('change');
        }
        $('#good_duty_rate').val($('#good_gtip_id').select2('data')[0]['duty_rate']).trigger('change');
        $('#good_excise_rate').val($('#good_gtip_id').select2('data')[0]['excise_rate']).trigger('change');
        $('#good_vat_rate').val($('#good_gtip_id').select2('data')[0]['vat_rate']).trigger('change');

        if (($('#good_gtip_id').val() !== '') && ($('#good_gtip_id').data('source-record') !== 'ncts')) {
          Traderdec.get_gtip_measures();
        }
        if (($('#good_gtip_id').select2('data')[0]['duty_calc_formul'] !== '') && ($('#good_gtip_id').data('source-record') === 'ncts')) {
          if ($('#good_calc_formul').length > 0) {
            var formul_src = $('#good_gtip_id').select2('data')[0]['duty_calc_formul'];
            if (formul_src !== '' && formul_src !== null) {
              $('#good_calc_formul_src').val(formul_src);
              $('.duty-calc-formul-fields').show();
              Good.calculate_taxes();
            } else {
              $('#good_calc_formul').val(null);
              $('#good_calc_formul_src').val(null);
              $('.duty-calc-formul-fields').hide();
              Good.calculate_taxes();
            }
          }
          var user_fields = $('#good_gtip_id').select2('data')[0]['additional_fields'];
          if (typeof user_fields !== typeof undefined && user_fields !== '' && user_fields !== null) {
            const fieldsArr = user_fields.split(",");
            if ((typeof fieldsArr[0] !== typeof undefined) && (fieldsArr[0] !== null) && (!["ADFM", "ADSZ", "DTN", "EA", "KGM", "TNE", ""].includes(fieldsArr[0]))) {
              $('.additional-data-1').show();
              $('#good_supplementary_unit_text').val(fieldsArr[0]).trigger('change');
            } else {
              $('.additional-data-1').hide();
              $('#good_supplementary_unit').val(null);
              $('#good_supplementary_unit_text').val(null);
            }
            if ((typeof fieldsArr[1] !== typeof undefined) && (fieldsArr[1] !== null) && (!["ADFM", "ADSZ", "DTN", "EA", "KGM", "TNE", ""].includes(fieldsArr[1]))) {
              $('.additional-data-2').show();
              $('#good_third_quantity_unit').val(fieldsArr[1]).trigger('change');
            } else {
              $('.additional-data-2').hide();
              $('#good_third_quantity').val(null);
              $('#good_third_quantity_unit').val(null);
            }
          } else {
            $('.additional-data-1').hide();
            $('.additional-data-2').hide();
            $('#good_supplementary_unit').val(null);
            $('#good_supplementary_unit_text').val(null);
            $('#good_third_quantity').val(null);
            $('#good_third_quantity_unit').val(null);
          }
        }
      } else {
        $('#good_gtip_id').empty();
        $('#good_gtip_id').val('');
        $('#good_gtip_code').val('');
        $('#duty_vat_info').html('');
        $('.additional-data-1').hide();
        $('.additional-data-2').hide();
        $('#good_supplementary_unit').val(null);
        $('#good_supplementary_unit_text').val(null);
        $('#good_third_quantity').val(null);
        $('#good_third_quantity_unit').val(null);
      }
    };

    var set_trailer_infos = function() {
      if ($('#manifesto_trailer_id').data('select2')) {
      $('#manifesto_trailer_coun').val($('#manifesto_trailer_id').select2('data')[0]['country_id']).trigger('change');
      $('#manifesto_trailer_code').val($('#manifesto_trailer_id').select2('data')[0]['text']);
      $('#manifesto_vehicle_coun').val($('#manifesto_trailer_id').select2('data')[0]['country_id']).trigger('change');
      }
    };

    var set_vehicle_infos = function() {
      if ($('#manifesto_vehicle_id').data('select2')) {
      $('#manifesto_vehicle_coun').val($('#manifesto_vehicle_id').select2('data')[0]['country_id']).trigger('change');
      $('#manifesto_vehicle_code').val($('#manifesto_vehicle_id').select2('data')[0]['text']);
      $('#manifesto_trailer_coun').val($('#manifesto_vehicle_id').select2('data')[0]['country_id']).trigger('change');
      }
    };

    var set_status_input_fields = function() {
      $('.manifesto_status_fields').hide();
      var new_status = $('#manifesto_status').val();
      if (new_status != '') {
      if (new_status != 'rejected' && new_status != 'waiting' && new_status != 'cancellation_requested') {
        $('#'+ new_status +'_input_field').show();
      } else {
        $('#cancelled_input_field').show();
      }
      }
    };

    var set_summary_exit_entry = function() {
      $('#manifesto_security').prop('checked', true);
      $('#manifesto_summary_entry').prop('checked', true);
      $('#manifesto_summary_exit').prop('checked', true);
      var departure_country = $('#manifesto_departure_custom_id').select2('data')[0]['country_id'];
      var doc_type = $('#manifesto_doc_type').val();
      if (departure_country == 'RO' && doc_type == 'T1' ) {
        $('#manifesto_summary_exit').prop('checked', false);
        $('#manifesto_summary_entry').prop('checked', true);
      } else if (departure_country == 'RO' && doc_type == 'T2') {
        $('#manifesto_summary_exit').prop('checked', true);
        $('#manifesto_summary_entry').prop('checked', false);
      } else if (doc_type == 'TR') {
        $('#manifesto_security').prop('checked', false);
        $('#manifesto_summary_entry').prop('checked', false);
        $('#manifesto_summary_exit').prop('checked', false);
      } else if (departure_country != 'TR') {
        $('#manifesto_trans_method').val('road').trigger('change');
      }
    };

    var toggle_departure_custom_related_fields = function() {
      if ($('#manifesto_departure_custom_id').length > 0) {
        var departure_country = $('#manifesto_departure_custom_id').select2('data')[0]['country_id'];
        departure_country = departure_country || $('#manifesto_load_coun').val();
        if (departure_country) {
          $('[data-available-countries]').each(function() {
            var country_field = $(this);
            country_field.toggle(country_field.data('available-countries').includes(departure_country) ? true : false);
          });
        }
        if (departure_country == "PL"){
          $(document).ready(function() {
            toggle_details_for_PL();
        });
        }
      }
    };

    var toggle_details_for_PL = function() {
      $('#location_detail-div, #details-form').show();
      $('#location_detail-link, #details-link').hide();
    };

    var set_ncts5_checker_active = function() {
      if ($('#manifesto_departure_custom_id').length > 0) {
        var departure_country = $('#manifesto_departure_custom_id').select2('data')[0]['country_id'];
        departure_country = departure_country || $('#manifesto_load_coun').val();
        if (departure_country) {
          if (["DE","LV","EE"].includes(departure_country)) {
            $('#manifesto_ncts5_checker').prop("checked", true);
          } else {
            $('#manifesto_ncts5_checker').prop("checked", false);
          }
        }
      }
    }

    var set_ro_different_customs_box = function() {
      $("#good_exp_customs_partial").prop('checked', false);
      var dep_custom_country_id = $('#good_invoice_country_id').val();
      var dep_custom_code = $('#manifesto_departure_custom_code').val();
      var exp_customs_no  = $('#good_exp_customs_no').val();
      if ((exp_customs_no != '') && (dep_custom_country_id == 'RO')) {
        exp_customs_no_custom_code = exp_customs_no.substr(2, 8);
        if (exp_customs_no_custom_code != dep_custom_code) {
          $("#good_exp_customs_partial").prop('checked', true);
        }
      }
    };

    var set_invoice_info_attributes = function() {
      if ($('#costform_finitem_id').data('select2')) {
        var involine_type = $("#costform_finitem_id").select2('data')[0]['involine_type'];
        if (typeof involine_type !== typeof undefined && involine_type !== false && involine_type) {
          if (involine_type == 'travel_pay' || involine_type == 'stoppage') {
            $('#invoice_company').hide();
            $("#invoice_info").hide();
            $('#vat_info').hide();
          } else {
            $('#invoice_company').show();
            $('#vat_info').show();
          }
        }
      }
    };

    var set_invoice_attributes = function() {
      if ($('#costform_has_invoice').val() == "yes") {
        $("#invoice_info").show();
        $(".costform_invoice_company_id").hide();
      }else{
        $("#invoice_info").hide();
        $(".costform_invoice_company_id").show();
      }
    };

    var trade_reason_code = function() {
      if ($('#trade_status').val() == "failure" || $('#trade_status').val() == "cancelled") {
        $("#trade_reason_code").show();
      }else{
        $("#trade_reason_code").hide();
      }
    };

    var calculate_costform_vat_amount = function() {
      var $unit_price, $vat_amount, $vat_rate;
      $vat_rate = parseFloat($("#costform_vat_id").find(":selected").attr('data-rate')) || 0;
      $unit_price = parseFloat($("#costform_price").val()) || 0;
      $vat_amount = parseFloat($unit_price - (($unit_price * 100) / (100 + $vat_rate)));
      $("#costform_vat_amount").val($vat_amount.toFixed(2));
    };

    var set_region_inputs = function(city_id, region_select_box_id) {
      $.ajax({
        type: "GET",
        url: "/regions",
        dataType: "script",
        data: {
          id: city_id,
          regions_select_id: region_select_box_id
        }
      });
    };

    var set_company_id_for_tender = function() {
      if (typeof $('#tender_company_id').select2('data') !== typeof undefined) {
        var delivery_city_id = $('#tender_company_id').select2('data')[0]['city_id'];
        var delivery_city_name = $('#tender_company_id').select2('data')[0]['city_name'];
        $('#tender_load_address').val($('#tender_company_id').select2('data')[0]['address']);
        $('#tender_load_country_id').val($('#tender_company_id').select2('data')[0]['country_id']);
        $('#tender_load_city_id').append("<option value='" + delivery_city_id + "' selected>" + delivery_city_name + "</option>");
      }
    }

    var set_load_place_type_for_tender = function() {
      var selected_place_type = $('#tender_load_place_type').val();
      if (typeof selected_place_type !== typeof undefined) {
        if (selected_place_type == 'sea' || selected_place_type == 'air' || selected_place_type == 'rail' || selected_place_type == 'custom') {
          $('.load_address_selection').hide();
          $('.load_city_selection').hide();
          $('.load_place_selection').show();
          $('#tender_load_place_id').attr('data-place-type', selected_place_type);
        } else {
          $('.load_address_selection').show();
          $('.load_city_selection').show();
          $('.load_place_selection').hide();
          $('#tender_load_place_id').attr('data-place-type', '');
          $("#tender_load_place_id").val('').trigger('change');
        }
      }
    }

    var set_unload_place_type_for_tender = function(){
      var selected_place_type = $('#tender_unload_place_type').val();
      if (typeof selected_place_type !== typeof undefined) {
        if (selected_place_type == 'sea' || selected_place_type == 'air' || selected_place_type == 'rail' || selected_place_type == 'custom') {
          $('.unload_address_selection').hide();
          $('.unload_city_selection').hide();
          $('.unload_place_selection').show();
          $('#tender_unload_place_id').attr('data-place-type', selected_place_type);
        } else {
          $('.unload_address_selection').show();
          $('.unload_city_selection').show();
          $('.unload_place_selection').hide();
          $('#tender_unload_place_id').attr('data-place-type', '');
          $('#tender_unload_place_id').val('').trigger('change');
        }
      }
    }

    $(document).on("change", "select[data-form-model='booking_company_id']", function(event) {
      if ($("select[data-form-model='booking_company_id']").val() !== null || $("select[data-form-model='booking_company_id']").val() !== '') {
        get_company_locations($("select[data-form-model='booking_company_id']").val(), 'company_locations');
      }
    });

    $(document).on("change", ["#costform_vat_id", "#costform_price"], function(event) {
      calculate_costform_vat_amount();
    });

    $(document).on("change", "#costform_finitem_id", function(event) {
      set_invoice_info_attributes();
    });

    $(document).on("change", "#costform_has_invoice", function(event) {
      set_invoice_attributes();
    });
    set_invoice_info_attributes();
    set_invoice_attributes();

    $(document).on("change", "#trade_status", function(event) {
      trade_reason_code();
    });
    trade_reason_code(); 

    $(document).on("change", "#loading_sender_id", function(event) {
      if ($("#loading_loader_id").val() === null || $("#loading_loader_id").val() === '' || $("#loading_loader_id").val() === undefined) {
        if (modaltrans.current_appview !== 'v2') {
          set_company_address($('#loading_sender_id').select2('data')[0], "loading");
        }
      }
      get_company_locations($('#loading_sender_id').val(), 'sender_locations');
    });

    $(document).on("change", "#loading_loader_id", function(event) {
      if ($("#loading_loader_id").val() !== null && $("#loading_loader_id").val() !== '') {
        set_company_address($('#loading_loader_id').select2('data')[0], "loading");
        get_company_locations($('#loading_loader_id').val(), 'loader_locations');
      }
    });
    if ($('#loading_loader_id').val()) {
      set_location_hint($('#loading_load_place').val(), 'loading_loader_id');
      get_company_locations($('#loading_loader_id').val(), 'loader_locations');
    }

    $(document).on("change", "#loading_consignee_id", function(event) {
      if ($("#loading_delivery_id").val() === null || $("#loading_delivery_id").val() === '' || $("#loading_delivery_id").val() === undefined) {
        if (modaltrans.current_appview !== 'v2') {
          set_company_address($('#loading_consignee_id').select2('data')[0], "unloading");
        }
      }
      get_company_locations($('#loading_consignee_id').val(), 'consignee_locations');
    });

    $(document).on("change", "#loading_delivery_id", function(event) {
      if ($("#loading_delivery_id").val() !== null && $("#loading_delivery_id").val() !== '') {
        set_company_address($('#loading_delivery_id').select2('data')[0], "unloading");
        get_company_locations($('#loading_delivery_id').val(), 'delivery_locations');
      }
    });
    if ($('#loading_delivery_id').val()) {
      set_location_hint($('#loading_unload_place').val(), 'loading_delivery_id');
      get_company_locations($('#loading_delivery_id').val(), 'delivery_locations');
    }

    $(document).on("change", "#position_coagent_id", function(event) {
      if ($("#position_coagent_id").val() !== null && $("#position_coagent_id").val() !== '') {
        set_company_address($('#position_coagent_id').select2('data')[0], 'dep_place');
        get_company_locations($('#position_coagent_id').val(), 'loader_locations');
      }
    });
    if ($('#position_coagent_id').val()) {
      set_location_hint($('#position_dep_address').val(), 'position_coagent_id');
      get_company_locations($('#position_coagent_id').val(), 'loader_locations');
    }

    $(document).on("change", "#position_agent_id", function(event) {
      if ($("#position_agent_id").val() !== null && $("#position_agent_id").val() !== '') {
        set_company_address($('#position_agent_id').select2('data')[0], 'arv_place');
        get_company_locations($('#position_agent_id').val(), 'delivery_locations');
      }
    });
    if ($('#position_agent_id').val()) {
      set_location_hint($('#position_arv_address').val(), 'position_agent_id');
      get_company_locations($('#position_agent_id').val(), 'delivery_locations');
    }

    $(document).on("change", "#point_origin_company_id", function(event) {
      set_company_address($('#point_origin_company_id').select2('data')[0], "origin_company_locations");
      get_company_locations($('#point_origin_company_id').val(), 'origin_company_locations');
    });

    $(document).on("change", "#point_destination_company_id", function(event) {
      set_company_address($('#point_destination_company_id').select2('data')[0], "destination_company_locations");
      get_company_locations($('#point_destination_company_id').val(), 'destination_company_locations');
    });

    $(document).on("change", "#lead_company_id", function(event) {
      if ($("#lead_company_id").val() !== null && $("#lead_company_id").val() !== '') {
        get_company_locations($('#lead_company_id').val(), 'sender_locations');
        get_company_locations($('#lead_company_id').val(), 'consignee_locations');
      }
    });

    $(document).on("change", ".nested-company-id", function (event) {
      const $this = $(this);
      const companyId = $this.attr("id");
      const companyData = $this.select2("data")[0];
    
      set_nested_company_address(companyData, companyId);
      get_company_locations($this.val(), companyId.replace("company_id", "locations"), true);
    });

    $('.nested-company-id').each(function() {
      const $this = $(this);

      if ($this.val()) {
        const companyId = $this.attr("id");
        const companyAddress = $("." + companyId.replace("company_id", "address")).val();

        set_location_hint(companyAddress, companyId);
        get_company_locations($this.val(), companyId.replace("company_id", "locations"), true);
      }
    });

    $(document).on("change", "#loading_load_place_id, #loading_unload_place_id, #position_dep_place_id, #position_arv_place_id", function(event) {
      const $this = $(this);
      const placeData = $this.select2("data")[0];

      set_location_hint(placeData.geocode_address, $this.attr("id"));
    });

    $('#loading_load_place_id, #loading_unload_place_id, #position_dep_place_id, #position_arv_place_id').each(function() {
      const $this = $(this);

      $.ajax({
        type: "GET",
        url: "/places/" + $this.val(),
        dataType: "json",
        success: function(data) {
          if (data) {
            set_location_hint(data.geocode_address, $this.attr("id"));
          }
        }
      }); 
    });

    $(document).on("change", "#position_dep_place_id", function(event) {
      var depPlace = $("#position_dep_place_id").select2('data')[0];
      $('#dep_address_block').text(depPlace.address ? depPlace.address : "No address");
    });

    $('.nested-company-id').each(function() {
      const $this = $(this);

      if ($this.val()) {
        const companyId = $this.attr("id");
        const companyAddress = $("." + companyId.replace("company_id", "address")).val();

        set_location_hint(companyAddress, companyId);
        get_company_locations($this.val(), companyId.replace("company_id", "locations"), true);
      }
    });

    $(document).on("change", ".show-place-details-in-hint", function(event) {
      const $this = $(this);
      const placeData = $this.select2("data")[0];

      set_location_hint(placeData.geocode_address, $this.attr("id"));
    });

    $(document).ready(function() {
      $('.show-place-details-in-hint').each(function() {
        const $this = $(this);
        const id    = $this.attr("id");
        const value = $this.val();

        if (value) {
          fetchPlaceDetails(value, id);
        } else {
          set_location_hint("undefined", id);
        }
      });
    });

    function fetchPlaceDetails(value, id) {
      $.ajax({
        type: "GET",
        url: `/places/${value}`,
        dataType: "json",
        success: (data) => {
          if (data) {
            set_location_hint(data.geocode_address, id);
          }
        }
      });
    }

    $(document).on("change", ".tax_exclude_code", function(event){
      Invoice.set_tax_exclude_rate(this);
    });

    $(document).on("change", "#findoc_account_id", function (evt) {
      var data = $(this).select2('data');
      if (data[0].curr !== null && data[0].curr !== '' && data[0].curr !== undefined) {
        $('#findoc_curr').val(data[0].curr).trigger('change');
      }
    });

    $(document).on("change", ".doc-curr", function(event) {
      FinDoc.change_curr_rate(this);
    });

    $(document).on("change", ".ledger_account_select", function (event) {
        set_ledger_account_details(this);
    });

    $(document).on("change", "#good_sender_id", function(event) {
      if ($("#good_sender_id").val() !== null && $("#good_sender_id").val() !== '') {
        get_company_locations($('#good_sender_id').val(), 'sender_locations');
      }
    });

    $(document).on("change", "#good_consignee_id", function(event) {
      if ($("#good_consignee_id").val() !== null && $("#good_consignee_id").val() !== '') {
        get_company_locations($('#good_consignee_id').val(), 'consignee_locations');
      }
    });

    $(document).on("change", "#traderdec_consignor_id", function(event) {
      if ($("#traderdec_consignor_id").val() !== null && $("#traderdec_consignor_id").val() !== '') {
        get_company_locations($('#traderdec_consignor_id').val(), 'sender_locations');
      }
    });

    $(document).on("change", "#traderdec_consignee_id", function(event) {
      if ($("#traderdec_consignee_id").val() !== null && $("#traderdec_consignee_id").val() !== '') {
        get_company_locations($('#traderdec_consignee_id').val(), 'consignee_locations');
        if ($("#traderdec_status").val() == "draft") {
          Traderdec.set_ducr();
        }
      }
    });

    // $(document).on("change.select2", "#traderdec_consignor_country_id", function() {
    //   Traderdec.set_export_country();
    // });
    // $(document).on("change.select2", "#traderdec_consignee_country_id", function() {
    //   Traderdec.set_import_country();
    // });

    $(document).on('change', '#road_voyage_trailer_id', function(event) {
      Voyage.set_positions_view();
    });

    $(document).on("change", "#loading_company_id", function(event) {
      if ($("#loading_company_id").val() !== null && $("#loading_company_id").val() !== '') {
        get_company_locations($('#loading_company_id').val(), 'sender_locations');
        get_company_locations($('#loading_company_id').val(), 'consignee_locations');
      }
    });

    $(document).on("change", "#uetd_line_sender_id", function() {
      set_sender_infos($(this).val());
    });

    $(document).on("change", "#uetd_line_consignee_id", function() {
      set_consignee_infos($(this).val());
    });

    $(document).on("change", "#tender_company_id", function(){
      set_company_id_for_tender();
    });
    set_company_id_for_tender();

    $(document).on("change", "#tender_load_place_type", function (evt) {
      set_load_place_type_for_tender();
    });
    set_load_place_type_for_tender();

    $(document).on("change", "#tender_unload_place_type", function (evt) {
      set_unload_place_type_for_tender();
    });
    set_unload_place_type_for_tender();

    $(document).on("change", "#tender_load_place_id", function(){
      $('#tender_load_country_id').val($('#tender_load_place_id').select2('data')[0]['country_id']).trigger('change');
    }); 

    $(document).on("change", "#tender_unload_place_id", function(){
      $('#tender_unload_country_id').val($('#tender_unload_place_id').select2('data')[0]['country_id']);
    });

    $(document).on("change", "#manifesto_dispatch_country_id", function() {
        set_load_place();
      });

      $(document).on("change", "#manifesto_destination_country_id", function() {
        set_unload_place();
      });

      $(document).on("change.select2", "#good_gtip_id", function(event) {        
        set_gtip_infos();
      });

      $(document).on("change", "#good_exp_customs_no", function(event) {
        set_ro_different_customs_box();
      });

      $(document).on("change", "#manifesto_trailer_id", function(event) {
        set_trailer_infos();
      });

      $(document).on("change", "#manifesto_vehicle_id", function(event) {
        set_vehicle_infos();
      });

      $(document).on("change", "#manifesto_status", function(event) {
        set_status_input_fields();
      });

      $(document).on("change", "#good_sender_id", function(event) {
        set_company_address($('#good_sender_id').select2('data')[0], "good_sender");
      });

      $(document).on("change", "#good_consignee_id", function(event) {
        set_company_address($('#good_consignee_id').select2('data')[0], "good_consignee");
      });

      $(document).on("change", "#manifesto_departure_custom_id", function(event) {
        set_summary_exit_entry();
        toggle_departure_custom_related_fields();
        set_ncts5_checker_active();
      });
      toggle_departure_custom_related_fields();

      $(document).on("change", "#manifesto_doc_type", function(event) {
        set_summary_exit_entry();
      });

    $(document).on("change", "#uetd_line_dep_city_id", function() {
      if (typeof $(this).val() !== typeof undefined && $(this).val() !== false && $(this).val() != null && $(this).val() != '') {
        set_region_inputs($(this).val(), "uetd_line_dep_district_id");
      }
    });

    $(document).on("change", "#uetd_line_arv_city_id", function() {
      if (typeof $(this).val() !== typeof undefined && $(this).val() !== false && $(this).val() != null && $(this).val() != '') {
        set_region_inputs($(this).val(), "uetd_line_arv_district_id");
      }
    });

    $(document).on("change", ".vehicle-select", function(event) {
      if ($(this).val() != '') {
        if ($(this).select2('data')[0]['driver_id'] !== '' && $(this).select2('data')[0]['driver_id'] !== null && $(this).select2('data')[0]['driver_id'] !== typeof undefined && $(this).data('driver-field') && $('#'+$(this).data('driver-field')).val() == '') {
          var newOption = new Option($(this).select2('data')[0]['driver_name'], $(this).select2('data')[0]['driver_id'], false, true);
          $('#'+$(this).data('driver-field')).append(newOption).trigger('change');
        }
        if ($(this).select2('data')[0]['person_id'] !== '' && $(this).select2('data')[0]['person_id'] !== null && $(this).select2('data')[0]['person_id'] !== typeof undefined && $(this).data('person-field') && $('#'+$(this).data('person-field')).val() == '') {
          var newOption = new Option($(this).select2('data')[0]['person_name'], $(this).select2('data')[0]['person_id'], false, true);
          $('#'+$(this).data('person-field')).append(newOption).trigger('change');
        }
        if (($(this).select2('data')[0]['covehicle_id'] !== '' && $(this).select2('data')[0]['covehicle_id'] !== null && $(this).select2('data')[0]['covehicle_id'] !== typeof undefined) && $(this).data('covehicle-field') && (($('#'+$(this).data('covehicle-field')).val() == '') || ($('#'+$(this).data('covehicle-field')).val() == 0))) {
          var newOption = new Option($(this).select2('data')[0]['covehicle_code'], $(this).select2('data')[0]['covehicle_id'], false, true);
          $('#'+$(this).data('covehicle-field')).append(newOption).trigger('change');
        }
      } else {
        $('#'+$(this).data('driver-field')).val(null).trigger('change');
      }
    });

    $(document).on('change', '#tracking_master_carrier_input', function() {
      const selectedData = $(this).select2('data')[0];
      const carrierCode  = selectedData["iata_code"];
      const trackingBy   = getTrackingBy(selectedData["operation_notes"], carrierCode);
      const helpText     = (trackingBy === 'BL') ? "required" : "optional";
      $('.tracking_master_mbl_no > .help-block').text(helpText);
      $("#tracking_master_carrier_code").val(carrierCode);
      $("#tracking_master_tracking_by").val(trackingBy);
    });

    function getTrackingBy(availableMethods, carrierCode) {
      if (modaltrans.current_patron_id !== 1772) {
        var carrierCodes = ["ARKU", "EGLV", "MEDU", "MSCU", "ONEY", "YMLU", "MAEU", "COSU", "TRKU", "ZIMU"];
        if (carrierCodes.includes(carrierCode)) {
          return 'BL';
        }
      }

      if (availableMethods[0] === '1') {
        return 'CT';
      } else if (availableMethods[1] === '1') {
        return 'BL';
      } else if (availableMethods[2] === '1') {
        return 'BK';
      } else {
        return null;
      }
    }
  }

  var initClipboard = function(clipboard_btn) {
    const data = [new ClipboardItem({ "text/plain": new Blob([clipboard_btn.dataset.clipboardText], { type: "text/plain" }) })];
    navigator.clipboard.write(data).then(function() {
      console.log("Copied to clipboard successfully!");
    }, function() {
      console.error("Unable to write to clipboard. :-(");
    });
  }

  var initDatetimepicker = function() {

    if (modaltrans.current_date_format) {
      var current_date_format = modaltrans.current_date_format.replace(/(\w)\1+/g, '$1').replace(/y/g, 'Y') ;
    } else {
      var current_date_format = 'd/m/Y';
    }

    flatpickr('[data-plugin="datepicker"]', {
      altInput: true,
      altFormat: current_date_format,
      // locale: modaltrans.current_locale,
      dateFormat: "Y-m-d",
      locale: {
        firstDayOfWeek: 1
      },
      allowInput: true,
      onClose: function (dates, currentdatestring, instance) {
        instance.setDate(instance.altInput.value, true, instance.config.altFormat)
      }
    });

    $('[data-plugin="datetimepicker"]').each(function() {
      $(this).flatpickr({
        enableTime: true,
        altInput: true,
        altFormat: current_date_format + " H:i",
        dateFormat: "Y-m-d H:i",
        locale: {
          firstDayOfWeek: 1
        },
        time_24hr: true,
        allowInput: true,
        defaultDate: $(this).val(),
        onClose: function (dates, currentdatestring, instance) {
          instance.setDate(instance.altInput.value, true, instance.config.altFormat)
        }
      });
    });

    $('[data-plugin="timepicker"]').each(function() {
      $(this).flatpickr({
        // locale: modaltrans.current_locale,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        defaultDate: $(this).val()
      });
    });

    $('[data-plugin="datepickerday"]').each(function() {
      $(this).flatpickr({
        altInput: true,
        altFormat: current_date_format,
        // locale: modaltrans.current_locale,
        minDate: "today",
        altFormat: "F j, Y l",
        dateFormat: "Y-m-d",
        locale: {
          firstDayOfWeek: 1
        },
        allowInput: true,
      });
    });
  }

  var initGmapsAutoComplete = function() {
    $('[data-plugin="gmaps-autocomplete"]').each(function() {
      const options = {
        fields: ['address_components', 'formatted_address', 'geometry', 'icon', 'name', 'place_id'],
        strictBounds: false,
      };
      const input_field_id   = $(this).attr('id');
      const maps_fields_mode = $(this).data('maps-fields-mode');
      const autocomplete = new google.maps.places.Autocomplete(document.getElementById(input_field_id), options);
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("No details available for input: '" + place.name() + "'");
          return;
        }

        // If the place has a geometry, then present it on a map.
        const adr_hash = new Map();
        const addr_arr = place.address_components;
        addr_arr.forEach(function(addr) {
          if (addr.types.indexOf('country') > -1) {
            adr_hash.set("country_id", addr.short_name);
          } else if (addr.types.indexOf('postal_code') > -1) {
            adr_hash.set("post_code", addr.long_name);
          } else if (addr.types.indexOf('administrative_area_level_1') > -1) {
            adr_hash.set("city_name", addr.long_name);
          } else {
            adr_hash.set("address",  ((adr_hash.get("address") || '') + ' ' + addr.long_name).trim());
          }
        });

        if (maps_fields_mode === 'nested') {
          var postcodeField    = document.getElementById(input_field_id.replace('address', 'postcode'));
          if (adr_hash.get("post_code") !== undefined) {
            if (postcodeField  !== null) postcodeField.value = adr_hash.get("post_code");
          } else if (postcodeField) {
            postcodeField.value = null
          }
          var countryField     = document.getElementById(input_field_id.replace('address', 'country_id'));
          if (countryField   !== null) countryField.value = adr_hash.get("country_id");
          var latitudeField    = document.getElementById(input_field_id.replace('address', 'lat'));
          if (latitudeField  !== null) latitudeField.value = place.geometry.location.lat();
          var longitudeField   = document.getElementById(input_field_id.replace('address', 'lng'));
          if (longitudeField !== null) longitudeField.value = place.geometry.location.lng();
          var nameField        = document.getElementById(input_field_id.replace('address', 'name'));
          if (nameField      !== null) nameField.value = place.name;
        } else {
          var postcodeField    = document.getElementById($(this).data('maps-fields-postcode'));
          if (adr_hash.get("post_code") !== undefined) {
            if (postcodeField  !== null) postcodeField.value = adr_hash.get("post_code");
          } else if (postcodeField) {
            postcodeField.value = null
          }
          var countryField     = document.getElementById($(this).data('maps-fields-country'));
          if (countryField   !== null) {
            countryField.value = adr_hash.get("country_id");
            countryField.dispatchEvent(new Event("change"));
          }
          var latitudeField    = document.getElementById($(this).data('maps-fields-latitude'));
          if (latitudeField  !== null) latitudeField.value = place.geometry.location.lat();
          var longitudeField   = document.getElementById($(this).data('maps-fields-longitude'));
          if (longitudeField !== null) longitudeField.value = place.geometry.location.lng();
          var nameField        = document.getElementById($(this).data('maps-fields-name'));
          if (nameField      !== null) nameField.value = place.name;
        }
      });
    });

    // $('#mapGoogle').each(function() {
    //   var data = $('#mapGoogle').attr('data-cars');
    //   var features = JSON.parse(decodeURIComponent(data)).features;
      
    //   if (features.length > 0) {
    //     var points_arr = []
    //     for(const feature of features) {
    //       points_arr.push({lat: parseFloat(feature.geometry.coordinates[0]), lng: parseFloat(feature.geometry.coordinates[1])});
    //     }

    //     const wayPointIndex = features[0].geometry.wayPointIndex;
    //     const map = new google.maps.Map(document.getElementById("mapGoogle"), {
    //       zoom: 3,
    //       center: { lat: parseFloat(features[wayPointIndex].geometry.coordinates[0]), lng: parseFloat(features[wayPointIndex].geometry.coordinates[1]) },
    //       mapTypeId: "terrain",
    //       disableDefaultUI: true
    //     });

    //     const flightPlanCoordinates = points_arr;

    //     const flightPath1 = new google.maps.Polyline({
    //       path: flightPlanCoordinates.slice(0, wayPointIndex + 1),
    //       geodesic: true,
    //       strokeColor: "#3699ff",
    //       strokeOpacity: 1.0,
    //       strokeWeight: 2,
    //       icons: [{
    //         icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
    //         offset: '100%',
    //         repeat: '50px'
    //       }]
    //     });

    //     flightPath1.setMap(map);

    //     const lineSymbol = {
    //       path: "M 0,-1 0,4",
    //       strokeOpacity: 1,
    //       scale: 2
    //     };

    //     const flightPath2 = new google.maps.Polyline({
    //       path: flightPlanCoordinates.slice(wayPointIndex),
    //       strokeOpacity: 0,
    //       strokeColor: "#3699ff",
    //       icons: [{
    //         icon: lineSymbol,
    //         offset: "0",
    //         repeat: "20px"
    //       }]
    //     });

    //     flightPath2.setMap(map);

    //     const startLatLng = flightPlanCoordinates[0];
    //     const startMarker = new google.maps.Marker({
    //       position: startLatLng,
    //       icon: {
    //         url: "http://maps.google.com/mapfiles/ms/micons/marina.png",
    //         scaledSize: new google.maps.Size(30, 30),
    //       },
    //       map: map
    //     });

    //     const wayPointLatLng = flightPlanCoordinates[wayPointIndex];
    //     const marker = new google.maps.Marker({
    //       position: wayPointLatLng,
    //       icon: {
    //         url: "https://maps.google.com/mapfiles/kml/shapes/sailing.png",
    //         scaledSize: new google.maps.Size(30, 30),
    //       },
    //       map: map,
    //     });

    //     const destinationLatLng = flightPlanCoordinates[flightPlanCoordinates.length - 1];
    //     const destinationMarker = new google.maps.Marker({
    //       position: destinationLatLng,
    //       icon: {
    //         url: "http://maps.google.com/mapfiles/ms/micons/red-pushpin.png",
    //         scaledSize: new google.maps.Size(30, 30),
    //       },
    //       map: map
    //     });
    //   }
    // });
  }

  var initFavoriteLocation = function () {
    $('.favourite-location-button, .favorite-search').on('click', function() {
      $('.nested-favorites').each(function () {
        var nestedAttributeId = $(this).find('.favorite-main-input').attr('name').split('][')[1];
        $(this).find('.favourite-location-button').attr('button-attribute-id', nestedAttributeId);
        $(this).find('.favorite-main-input').attr('input-attribute-id', nestedAttributeId);
        $(this).find('.favorite-item').attr('item-attribute-id', nestedAttributeId);
      });
    });
    $('.favourite-location-button').on('click', function() {
      if ($(this).attr('favorite-fields-mode') === 'nested') {
        var attributeId = $(this).attr('button-attribute-id');
        var element     = $("[input-attribute-id='" + attributeId + "']")
        var data_values = {
          'address' : element.val(),
          'lat'     : $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-latitude'))).val(),
          'lng'     : $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-longitude'))).val(),
          'country' : $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-country'))).val(),
          'zipcode' : $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-postcode'))).val()
        }
      } else {
        var klass   = $(this).attr("data-class");
        var element = $('.' + klass);
        var data_values = {
          'address' : element.val(),
          'lat'     : $('#' + element.attr('data-maps-fields-latitude')).val(),
          'lng'     : $('#' + element.attr('data-maps-fields-longitude')).val(),
          'country' : $('#' + element.attr('data-maps-fields-country')).val(),
          'zipcode' : $('#' + element.attr('data-maps-fields-postcode')).val()
        }
      }
      
      if (element.val() == '') return false;
      $.ajax({
        url: '/country_locations/new',
        type: 'GET',
        data: data_values,
        dataType: 'script'
      });
    });
  }

  var initSetFavoriteLocation = function () {
    $('.favorite-item').on('click', function() {
      var locationValue = {
        'address' : $(this).attr('address'),
        'lat'     : $(this).attr('lat'),
        'lng'     : $(this).attr('lng'),
        'country' : $(this).attr('country'),
        'zipcode' : $(this).attr('zipcode')
      }
      
      if ($(this).attr('scope') !== 'nested') {
        var element = $('.' + $(this).attr('scope'));
        element.val(locationValue.address);
        $('#' + element.attr('data-maps-fields-latitude')).val($(this).attr(locationValue.lat));
        $('#' + element.attr('data-maps-fields-longitude')).val($(this).attr(locationValue.lng));
        $('#' + element.attr('data-maps-fields-country')).val($(this).attr(locationValue.country));
        $('#' + element.attr('data-maps-fields-postcode')).val($(this).attr(locationValue.zipcode));
      } else {
        var attributeId = $(this).attr('item-attribute-id');
        var element     = $("[input-attribute-id='" + attributeId + "']");
        element.val(locationValue.address);
        $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-latitude'))).val(locationValue.lat);
        $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-longitude'))).val(locationValue.lng);
        $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-country'))).val(locationValue.country);
        $("#" + element.attr('id').replace('address', element.attr('data-maps-fields-postcode'))).val(locationValue.zipcode);
      }
    });
  }

  var setGroupContactAuths = function () {
    $(document).on("change", '[contact-form-type="group"]', function () {
      var doc_auth_id    = $(this).attr('id').replace('contact_id', 'doc_auth');
      var notify_auth_id = $(this).attr('id').replace('contact_id', 'notify_auth');
      var doc_auth       = $(this).select2('data')[0]['doc_auth'];
      var notify_auth    = $(this).select2('data')[0]['notify_auth'];

      $('#' + doc_auth_id).val(doc_auth);
      $('#' + notify_auth_id).val(notify_auth);
    });
  }

  var clearModalContents = function () {
    $(document).on('slidePanel::beforeHide', function (e) {
      $('.slidePanel-content').html(null);
    });

    $("#modalWindow").on("hidden.bs.modal", function(){
      $(this).html(null);
    });
  }

  var quickFilterHasValue = function () {
    $(document).on('change', '.quick-filter-input', function() {
      var quickFilterInput = $(this).attr("quick-filter-input");
      var inputValue   = $(this).val();
      if (inputValue.toString() !== '') {
        $('[quick-filter-button="' + quickFilterInput + '"]').removeClass('btn-light text-dark-65').addClass('bg-light-primary text-dark-75');
        $('[quick-filter-submit="' + quickFilterInput + '"]').prop('disabled', false);
      } else {
        $('[quick-filter-button="' + quickFilterInput + '"]').removeClass('bg-light-primary text-dark-75').addClass('btn-light text-dark-65');
        $('[quick-filter-submit="' + quickFilterInput + '"]').prop('disabled', true);
      }
      quickFilterClearAll();
    });
  }

  var quickFilterClearAll = function () {
    var index = 0;
    $('.quick-filter-input').each(function() {
      var $this = $(this).val();
      if ($this.toString() !== '') {
        index += 1
      };
      if (index > 0) {
        $('#quick-filter-clear-btn').show();
      } else {
        $('#quick-filter-clear-btn').hide();
      };
    });
  }; 

  var quickFilterCancelLink = function () {
    $(document).on('click', '.quick-filter-cancel', function() {
      var filterCancel = $(this).attr("quick-filter-cancel");
      $('[quick-filter-input="' + filterCancel + '"]').val(null).trigger('change');
      quickFilterClearAll();
    }); 
  }; 

  var quickFilterClearAllValue = function () {
    $(document).on('click', '#quick-filter-clear-btn', function() {
      $('.quick-filter-input').val(null).trigger('change');
    });
  };

  function initializeQuickFilters() {
    quickFilterHasValue();
    quickFilterCancelLink();
    quickFilterClearAllValue();
  };

  var initSelectInput = function () {
    $('#main_search_dropdown select').change(function() {
      $(this).toggleClass('select-input__placeholder', !!$(this).val());
    });
  }

  var initWaypointComponents = function () {
    $(".waypoint-line .waypoint-place-type").each(function(){
      const waypointType = $(this).val();
      const waypointLine = $(this).closest('.waypoint-line');

      showByPlaceType(waypointType, waypointLine);
    });

    $(".waypoint-line .waypoint-place-type").change(function(){
      const placeTypeId = $(this).attr('id');
      const waypointType = $(this).val();
      const waypointLine = $(this).closest('.waypoint-line');

      $("#" + placeTypeId.replace("place_type", "company_id")).val(null).trigger('change');
      $("#" + placeTypeId.replace("place_type", "place_id")).val(null).trigger('change');
      $("#" + placeTypeId.replace("place_type", "address")).val(null);
      $("." + placeTypeId.replace("place_type", "address")).val(null);
      $("#" + placeTypeId.replace("place_type", "postcode")).val(null);
      $("#" + placeTypeId.replace("place_type", "country_id")).val(null).trigger('change');
      $("#" + placeTypeId.replace("place_type", "country_id")).val(null);
      $("#" + placeTypeId.replace("place_type", "city_id")).val(null).trigger('change');
      $("#" + placeTypeId.replace("place_type", "city_name")).val(null);
      $("#" + placeTypeId.replace("place_type", "latitude")).val(null);
      $("#" + placeTypeId.replace("place_type", "longitude")).val(null);
      $("#" + placeTypeId.replace("place_type", "place_id")).val(null).trigger('change');
      $("#" + placeTypeId.replace("place_type", "name")).val(null);
      $("#" + placeTypeId.replace("place_type", "state_name")).val(null);

      showByPlaceType(waypointType, waypointLine);
    });
  }

  var showByPlaceType = function (waypointType, waypointLine) {
    switch (waypointType) {
      case "gmaps":
        waypointLine.find(".waypoint-gmaps").show();
        waypointLine.find(".waypoint-gmaps-input").attr('disabled', false);
        waypointLine.find(".waypoint-address").hide();
        waypointLine.find(".waypoint-address-input").attr('disabled', true);
        waypointLine.find(".waypoint-address-details").hide();
        waypointLine.find(".waypoint-address-details").removeClass("collsapse show");
        waypointLine.find(".waypoint-place-div").hide();
        waypointLine.find(".waypoint-company").hide();

        break;
      case "customer":
        waypointLine.find(".waypoint-gmaps").hide();
        waypointLine.find(".waypoint-gmaps-input").attr('disabled', true);
        waypointLine.find(".waypoint-address").show();
        waypointLine.find(".waypoint-address-input").attr('disabled', false);
        waypointLine.find(".waypoint-address-details").show();
        waypointLine.find(".waypoint-address-details").addClass("collsapse");
        waypointLine.find(".waypoint-place-div").hide();
        waypointLine.find(".waypoint-company").show();

        break;
      case "port":
        waypointLine.find(".waypoint-gmaps").hide();
        waypointLine.find(".waypoint-gmaps-input").attr('disabled', true);
        waypointLine.find(".waypoint-address").hide();
        waypointLine.find(".waypoint-address-input").attr('disabled', false);
        waypointLine.find(".waypoint-address-details").hide();
        waypointLine.find(".waypoint-address-details").removeClass("collsapse show");
        waypointLine.find(".waypoint-place-div").show();
        waypointLine.find(".waypoint-company").hide();

        break;
    }
  }

  var initSpinner = function () {
    $(".slidingDiv").hide();
    $(".togglebutton").show();
    $(".show_group_content").hide();
    $("#search_panel_content").hide();
    $(".hide_search_panel_content").hide();
    
    $('#spinner').hide();
    var originalOpen = XMLHttpRequest.prototype.open;

    function toggleSpinner(isVisible) {
      $('#spinner').toggle(isVisible);
    }

    function onReadyStateChange() {
      if (this.readyState === 4) {
        toggleSpinner(false);
      }
    }

    XMLHttpRequest.prototype.open = function(method, url, async, user, pass) {
      toggleSpinner(true);
      this.addEventListener("readystatechange", onReadyStateChange, false);
      originalOpen.call(this, method, url, async, user, pass);
    };
  }

  var initModaltrans = function() {
    $(document).on("click", ".togglebutton", function(event) {
      var target = $(event.currentTarget);
      var $iconToggle = $(event.currentTarget).find("i");
      if (target.hasClass("collapsed")) {
        target.find(".list-arrow-rotate").removeClass("down");
        $iconToggle.removeClass("fas").addClass("far");
        target.find(".label-toggle").removeClass("text-dark");
      } else {
        target.find(".list-arrow-rotate").addClass("down");
        $iconToggle.removeClass("far").addClass("fas");
        target.find(".label-toggle").addClass("text-dark");
      }

      $(document).on("click", ".collapse-company", function() {
        if (!target.hasClass("collapsed")) {
          $(".setting-list").removeClass("setting-list-active");
        }
      });
      
      $($(this).data('href')).slideToggle();
      return event.preventDefault();
    });

    $(document).on("click", ".setting-list", function() {
      $(".setting-list").removeClass("setting-list-active");
      $(this).addClass("setting-list-active");
      $(".collapse-company i.fas").removeClass("fas").addClass("far");
      $(".collapse-company .label-toggle").removeClass("text-dark");
    });
    
    $(document).on("click", ".toggle_and_hide_button", function(event) {
      $($(this).data('href')).slideToggle();
      $($(this).data('href') + '-hide').hide();
      $(this).hide();
      return event.preventDefault();
    });
    $(document).on("click", ".hide_and_show_button", function(event) {
      var id_of_div = $(this).attr('id');
      if(id_of_div.includes("show")){
        $('#' + id_of_div).hide();
        document.getElementById(id_of_div.replace('show', 'hide')).style.display = "table-cell"
      }
      else{
        $('#' + id_of_div).hide();
        document.getElementById(id_of_div.replace('hide', 'show')).style.display = "table-cell"
      }
      return event.preventDefault();
    });
    $(document).on("click", ".hide_group_content", function(event) {
      var groupID;
      groupID = $(this).data('group-id');
      $($(this).data('href')).slideToggle();
      $(this).hide();
      $($('.show_group_content').filter('[data-group-id=' + groupID + ']')).show();
      return event.preventDefault();
    });
    $(document).on("click", ".select2-container", function(event) {
      event.stopPropagation();
    });
    $(document).on("click", ".dropdown-menu.keep-open", function(event) {
      event.stopPropagation();
    });
    $(document).on("click", ".select2-selection__choice__remove", function(event) {
      event.stopPropagation();
    });
    $('#close-dropdown').click(function() {
      $(this).closest('.dropdown-menu').prev().dropdown('toggle');
    });
    $('#submit-dropdown').click(function() {
      $('#main_search_dropdown').removeClass('open');
    });
    $(document).on("click", ".show_group_content", function(event) {
      var groupID;
      groupID = $(this).data('group-id');
      $($(this).data('href')).slideToggle();
      $(this).hide();
      $($('.hide_group_content').filter('[data-group-id=' + groupID + ']')).show();
      return event.preventDefault();
    });
    $(document).on("click", ".hide_search_panel_content", function(event) {
      $($(this).data('href')).slideToggle();
      $(this).hide();
      $('.show_search_panel_content').show();
      return event.preventDefault();
    });
    $(document).on("click", ".show_search_panel_content", function(event) {
      $($(this).data('href')).slideToggle();
      $(this).hide();
      $('.hide_search_panel_content').show();
      return event.preventDefault();
    });
    $(document).on("focus", "#post_message", function(event) {
      return $('.user-share-actions').removeClass('hidden');
    });
    $(document).on("click", ".tabswitcher", function(event) {
      $($(this).data('href')).tab('show');
      return event.preventDefault();
    });
    $(document).on("click", ".cancelbtn", function(event) {
      $($(this).data('href')).remove();
      return event.preventDefault();
    });
    $(".tile").click(function() {
      return window.location.href = $(this).data("url");
    });
    $(".dashboard-stat").click(function() {
      return window.location.href = $(this).data("url");
    });
    $(".widget[data-url]").click(function() {
      return window.location.href = $(this).data("url");
    });
    $(document).on("click", "#btn_close_search_form", function(event) {
      $("#page-search-form").removeClass('page-aside');
      $("#search-form-header").removeClass('page-aside-section');
      $("#search-form-header").html('');
      $("#search-form-body").html('');
      return event.preventDefault();
    });
    $(".simple_form").find("input[type=text],textarea,select").filter(":visible:first").not(".dont_focus").focus();
    $(document).on("click", ".emptyDiv", function(event) {
      $($(this).data('href')).html('');
      $($(this).data('show-btn')).removeClass('hidden-btn');
      return event.preventDefault();
    });
    $(document).on("click", ".hide_details", function(event) {
      $($(this).data("subview")).hide();
      $($(this).data("showlink")).css("display", "inline");
      $(this).css("display", "none");
      return event.preventDefault();
    });
    $('.show-complete-btn').on('click', function() {
      $(this).button('complete');
    });
    $(document).on("click", ".copy_text_button", function (evt) {
      initClipboard(this);
      $(this).fadeOut(100, function() { $(this).fadeIn(100); });
    });
    $(document).on('click', '.pagination a[data-remote=true]', function(e) {
      history.pushState({}, '', $(this).attr('href'));
    });
    $(window).on('popstate', function() {
      var remoteUrl;
      remoteUrl = '<a href=\'' + document.location.href + '\'' + ' data-remote=\'true\'></a>';
      $.rails.handleRemote($(remoteUrl));
    });
    $(document).on("keyup", ".search-reference", function(event) {
      var table, value;
      table = '.' + $(this).attr('search-table');
      value = this.value.toLowerCase().trim();
      $(table).find('tr').each(function(index) {
        var id;
        id = $(this).find('td').text().toLowerCase().trim();
        $(this).toggle(id.indexOf(value) !== -1);
      });
    });
    $('#simple_search_fields .select + .date_interval').hide();
    $('#simple_search_fields .select').on('change', function(event) {
      var input_id, input_value;
      if ($(this).val()) {
        input_id = $(this).attr('id');
        input_value = $(this).val();
        if (input_value === 'custom_date') {
          $('.' + input_id.substr(0, input_id.length - 7)).show();
        } else {
          $('.' + input_id.substr(0, input_id.length - 7)).hide();
        }
      }
    });

    $('label[data-profile-link]').each(function() {
      var label_text = $(this).html();
      $(this).html(label_text + '<a href=' + $(this).data('profile-link') + ' target="_blank" class="float-right profile-link"> Profile</a>');
    });
    $('.dropdown-menu a').on('click', function(e) {
      $('.dropdown').removeClass('open', 500);
    });
    $(document).ready(function() {
      $('.spinner').hide();
      $(document).ajaxStart(function() {
        $('.spinner').show();
      }).ajaxComplete(function() {
        $('.spinner').hide();
      });
      $(document).ajaxStop(function() {
        return $('.spinner').hide();
      });
    });
  };
 
  var append_email_to_list = function(target_field, email_addr) {
    var em = $('#'+target_field).val();
    if (em.indexOf(email_addr) < 0) {
    if (em == '') {
      em = email_addr
    } else {
      em = em + ', ' + email_addr;
    }
    $('#'+target_field).val(em);
    }
  };

  var set_deferment_accounts = function(scope) {
    var deferment_owner  = $('#traderdec_first_dan_type').val();
    if (scope === 'second') {
      deferment_owner = $('#traderdec_second_dan_type').val();
    }

    var deferment_acc_no = $('#traderdec_declarant_id').select2('data')[0]['taxoffice'];
    if ((deferment_acc_no === '') || (deferment_acc_no === null) || (typeof deferment_acc_no === typeof undefined)) {
      deferment_acc_no = $('#traderdec_declarant_id').data('taxoffice');
    }
    if (deferment_owner !== 'A') {
      deferment_acc_no = $('#traderdec_consignee_id').select2('data')[0]['taxoffice'];
      if ((deferment_acc_no === '') || (deferment_acc_no === null) || (typeof deferment_acc_no === typeof undefined)) {
        deferment_acc_no = $('#traderdec_consignee_id').data('taxoffice');
      }
    }
    if ((deferment_acc_no !== '') || (deferment_acc_no !== null))  {
      if (scope === 'second') {
        $('#traderdec_second_dan_no').val(deferment_acc_no);
      } else {
        $('#traderdec_first_dan_no').val(deferment_acc_no);
      }
    }
  }

  var reset_account_selection = function(account_type_field) {
    var account_type_field_id_str   = '#' + $(account_type_field).attr('id');
    var account_select_field        = account_type_field_id_str.replace('account_type', 'account_id');
    if (typeof account_select_field !== typeof undefined && account_select_field !== false) {
      $(account_select_field).val([]).trigger('change');
    }
  
    var profit_center_input     = account_type_field_id_str.replace('account_type', 'profit_center_id');
    if (typeof profit_center_input !== typeof undefined && profit_center_input !== false) {
      $(profit_center_input).val([]).trigger('change');
    }
  
    var ledger_account_input    = account_type_field_id_str.replace('account_type', 'ledger_account_id');
    if (typeof ledger_account_input !== typeof undefined && ledger_account_input !== false) {
      $(ledger_account_input).val([]).trigger('change');
    }
    };
  
    var set_account_type = function(account_field) {
      var account_selected = false
      var account_field_id_str      = '#' + $(account_field).attr('id');
  
      // Setting account type
      var account_type_field   = account_field_id_str.replace('account_id', 'account_type');
      if (typeof account_type_field !== typeof undefined && account_type_field !== false) {
        if (typeof $(account_field).select2('data')[0] !== typeof undefined && typeof $(account_field).select2('data')[0]['parent_type'] !== typeof undefined) {
        $(account_type_field).val($(account_field).select2('data')[0]['parent_type']);
        account_selected = true
        }
      }
      if (account_selected) {
        // Setting currency
        var currency_select  = account_field_id_str.replace('account_id', 'curr');
        var account_currency = $(account_field).select2('data')[0]['curr'];
        if (typeof currency_select !== typeof undefined && currency_select !== false && account_currency != null && account_currency != '') {
        $(currency_select).val(account_currency).trigger('change');
        }
    
        // Setting profit center
        var account_profit_center_id   = $(account_field).select2('data')[0]['profit_center_id'];
        var account_profit_center_name = $(account_field).select2('data')[0]['profit_center_name'];
        var profit_center_input        = account_field_id_str.replace('account_id', 'profit_center_id');
        if (typeof profit_center_input !== typeof undefined && profit_center_input !== false && account_profit_center_id != null) {
        $(profit_center_input).append("<option value='"+account_profit_center_id+"' selected>"+account_profit_center_name+"</option>").trigger('change');
        }
    
        // Setting ledger account 
        var ledger_account_id    = $(account_field).select2('data')[0]['ledger_account_id'];
        var ledger_account_name  = $(account_field).select2('data')[0]['ledger_account_name'];
        var ledger_account_input = account_field_id_str.replace('account_id', 'ledger_account_id');
        if (typeof ledger_account_id !== typeof undefined && ledger_account_id !== false && ledger_account_id != null) {
        $(ledger_account_input).val($(account_field).select2('data')[0]['parent_type']);
        }
    
        // Setting notes
        var account_name    = $(account_field).select2('data')[0]['name'];
        // var notes_input     = account_field_id_str.replace('account_id', 'notes');
        var notes_input     = ".findocline_notes";
        if (typeof account_name !== typeof undefined && account_name !== false && account_name != null && $(account_type_field).val() == 'Financor::BankAccount') {
        $(notes_input).val($(account_field).select2('data')[0]['name']);
        }
      }
    };

    var show_account_balances = function(account_field) {
      var account_id = $(account_field).val();
      if (account_id == '') {
        $("#account_balances").html('');
      } else {
        return $.ajax({
          type: "GET",
          url: "/ledger_entries/finstatus?position=inline&account_id=" + account_id ,
          dataType: "script"
        });
      }
    }

    var handleSelectedMotionBatch = function () {
      var selectedValues = $('.hub-motion-checkbox:checked').map((index, element) => element.value).get().join(',');
      var updateButton   = $('#motion_batch_update')

      if (selectedValues === '') {
        updateButton.addClass('disabled');
      } else {
        updateButton.removeClass('disabled');
      }

      var href    = $('#motion_batch_update').attr('href').replace(/hub_motion_ids=.*$/, "");;
      var newHref = href + (href.includes('?') ? '' : '?') + "hub_motion_ids=" + selectedValues;
      updateButton.attr('href', newHref);
    }
    
    $(document).on("change", "#traderdec_first_dan_type", function () {
      set_deferment_accounts('first');
    })
    $(document).on("change", "#traderdec_second_dan_type", function () {
      set_deferment_accounts('second');
    });

    $(document).on("change", ".account_type", function (event) {
    reset_account_selection(this);
    });

    $(document).on("change", ".account_select", function (event) {
    set_account_type(this);
    });

    $(document).on("change", "#findoc_related_account_id", function (evt) {
    show_account_balances(this);
    });

    $(document).on("change", "#findoc_findoclines_attributes_0_account_id", function(event) {
    if ($("#findoc_notes").val() == "") {
      $("#findoc_notes").val($("#findoc_findoclines_attributes_0_account_id").select2('data')[0]['name']);
      event.preventDefault();
    }
    });

    $(document).on("change", ".select-all-hub-motions", function(event) {
      $('.hub-motion-checkbox').prop('checked', $(this).prop('checked'));
      handleSelectedMotionBatch();
    });

    $(document).on("change", ".hub-motion-checkbox", function() {
      handleSelectedMotionBatch();
    });

  return {
    init: function (settingsArray) {
      if (settingsArray) {
        settings = settingsArray;
      }

      KTApp.initComponents();
    },

    initAjax: function () {
      KTApp.initComponents();
      $('.select2-container--open').remove();
    },

    initComponents: function () {
      initScroll();
      initTooltips();
      initPopovers();
      initAlerts();
      initFileInput();
      initCards();
      initStickyCard();
      initAbsoluteDropdowns();
      initSelect2();
      initTypeahead();
      initDatetimepicker();
      initSpinner();
      initGoTop();
      addNoneOptionToFilters();
      initGmapsAutoComplete();
      initFavoriteLocation();
      initSetFavoriteLocation();
      initializeQuickFilters();
      setGroupContactAuths();
      clearModalContents();
      initSelectInput();
      initWaypointComponents();
    },

    filterDropdownList: function(input_field_id, dropdown_list_id) {
      filterDropdownList(input_field_id, dropdown_list_id);
    },

    initTypeahead: function () {
      initTypeahead();
    },
  
    detailOpen: function (event) {
      detailOpen(event);
    },

    detailClose: function (event) {
      detailClose(event);
    },

    initTooltips: function () {
      initTooltips();
    },

    initTooltip: function (el) {
      initTooltip(el);
    },

    initPopovers: function () {
      initPopovers();
    },

    initPopover: function (el) {
      initPopover(el);
    },

    initCard: function (el, options) {
      initCard(el, options);
    },

    initCards: function () {
      initCards();
    },

    initSticky: function () {
      initSticky();
    },

    initAbsoluteDropdown: function (context) {
      initAbsoluteDropdown(context);
    },

    initModaltrans: function() {
      initModaltrans();
    },

    initGmaps: function () {
      initGmapsAutoComplete();
    },

    set_sender_infos: function (city_id) {
      set_sender_infos(city_id, "uetd_line_sender_id");
    },

    set_consignee_infos: function (city_id) {
      set_consignee_infos(city_id, "uetd_line_consignee_id");
    },

    block: function (target, options) {
      var el = $(target);

      options = $.extend(true, {
        opacity: 0.05,
        overlayColor: '#000000',
        type: '',
        size: '',
        state: 'primary',
        centerX: true,
        centerY: true,
        message: '',
        shadow: true,
        width: 'auto'
      }, options);

      var html;
      var version = options.type ? 'spinner-' + options.type : '';
      var state = options.state ? 'spinner-' + options.state : '';
      var size = options.size ? 'spinner-' + options.size : '';
      var spinner = '<span class="spinner ' + version + ' ' + state + ' ' + size + '"></span';

      if (options.message && options.message.length > 0) {
        var classes = 'blockui ' + (options.shadow === false ? 'blockui' : '');

        html = '<div class="' + classes + '"><span>' + options.message + '</span>' + spinner + '</div>';

        var el = document.createElement('div');

        $('body').prepend(el);
        KTUtil.addClass(el, classes);
        el.innerHTML = html;
        options.width = KTUtil.actualWidth(el) + 10;
        KTUtil.remove(el);

        if (target == 'body') {
          html = '<div class="' + classes + '" style="margin-left:-' + (options.width / 2) + 'px;"><span>' + options.message + '</span><span>' + spinner + '</span></div>';
        }
      } else {
        html = spinner;
      }

      var params = {
        message: html,
        centerY: options.centerY,
        centerX: options.centerX,
        css: {
          top: '30%',
          left: '50%',
          border: '0',
          padding: '0',
          backgroundColor: 'none',
          width: options.width
        },
        overlayCSS: {
          backgroundColor: options.overlayColor,
          opacity: options.opacity,
          cursor: 'wait',
          zIndex: (target == 'body' ? 1100 : 10)
        },
        onUnblock: function () {
          if (el && el[0]) {
            KTUtil.css(el[0], 'position', '');
            KTUtil.css(el[0], 'zoom', '');
          }
        }
      };

      if (target == 'body') {
        params.css.top = '50%';
        $.blockUI(params);
      } else {
        var el = $(target);
        el.block(params);
      }
    },

    unblock: function (target) {
      if (target && target != 'body') {
        $(target).unblock();
      } else {
        $.unblockUI();
      }
    },

    blockPage: function (options) {
      return KTApp.block('body', options);
    },

    unblockPage: function () {   
      return KTApp.unblock('body');
    },

    getSettings: function () {
      return settings;
    },

    showMessage: function (msgtext, msgtype, msgicon) {
      Swal.fire({text: msgtext, type: msgtype, icon: msgicon, allowEscapeKey: true, timer: 7000});
    },

    toastMessage: function (msgtext, msgtype, position ) {
      var position = (position === undefined) ? 'center' : position;
      Swal.fire({toast: true, icon: msgtype, title: msgtext, animation: false, position: position, showConfirmButton: false, timer: 3000, timerProgressBar: true, didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
    },

    showHintMessage: function (object) {
      var parsedObject = JSON.parse(object)

      $(function() {
        var form_selector = "#new_" + parsedObject.name + ", #edit_" + parsedObject.name + "_" + parsedObject.id;
        var forms         = $(form_selector);

        forms.each(function() {
          var form = $(this);
          form.find('.error-inputs').remove();
          form.find('.select2-selection').css("border-color", "#D1D3E0");
          form.find('input').css("border-color", "#D1D3E0");
        });

        $.each(parsedObject.errors, function(key, value) {
          var field_key = parsedObject.name + "_" + key;
          var error_message = value;

          forms.each(function() {
            var form             = $(this);
            var field_div        = form.find("." + field_key);
            var errorInputs      = field_div.find('.error-inputs');
            var inputElement     = field_div.find('input');
            var select2Selection = field_div.find('.select2-selection');

            errorInputs.remove();
            inputElement.css("border-color", "red");
            select2Selection.css("border-color", "red");

            field_div.append('<span class="help-block text-danger error-inputs">' + error_message + '</span>');
          });
        });
      });
    },

    add_input_field: function(input_name, target_id, label_text) {
      if (label_text !== null && label_text !== '') {
        document.getElementById(target_id).innerHTML = '<div class="form-group">' +
          '<label class="control-label string required" for='+ input_name +'">' + label_text + '</label>' +
          '<input type="password" class="form-control" name="' + input_name + '" id="' + input_name + '">' +
        '</div>';
      } else {
        document.getElementById(target_id).innerHTML = '<div class="form-group">' +
          '<input type="password" class="form-control" name="' + input_name + '" id="' + input_name + '">' +
        '</div>';
      }
    },

    add_fields: function (link, association, content) {
      var new_id = new Date().getTime();
      var regexp = new RegExp("new_" + association, "g");
      $(link).closest(".new_record_button").before(content.replace(regexp, new_id));
      KTApp.init(KTAppSettings);
    },

    append_email_to_list: function (target_field, email_addr) {
      append_email_to_list(target_field, email_addr)
    }
  };
}(); 

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = KTApp;
}

// Initialize KTApp class on document ready
$(document).ready(function () {
  KTApp.init(KTAppSettings);
  KTApp.initModaltrans();
  window.Site = KTApp;
}); 